export interface TextDataType {
    login_title: string
    login_subtitle: string
    login_email_title: string
    login_email_continue: string
    login_loading: string
    login_fail_toast: string
    login_email_miss_toast: string
    login_otp_miss_toast: string
    login_email_wrong_toast: string
    login_otp_send_toast: string
    login_network_error: string
    login_otp_title: string
    login_otp_continue: string
    login_get_otp_button: string
    login_otp_cd: string
    login_quick_use: string
    login_guest: string
    login_divider: string
    login_email_placeholder: string
    login_as_apple: string
    login_as_google: string
    login_tips: string
    login_sign_in: string
    login_sign_up: string
    login_welcome_back: string
    login_hero_tagline: string
    login_hero_desc: string
    login_brand: string
    login_access_terminal: string
    app_play: string
    app_share: string
    // puzzle_chat
    puzzle_soup_label: string
    puzzle_publish: string
    puzzle_reviewing: string
    puzzle_like: string
    puzzle_input_placeholder: string
    puzzle_report_title: string
    puzzle_report_description: string
    puzzle_report_reason_label: string
    puzzle_report_extra_label: string
    puzzle_report_extra_placeholder: string
    puzzle_report_cancel: string
    puzzle_report_submit: string
    puzzle_report_submitting: string
    puzzle_report_confirm: string
    puzzle_report_success: string
    puzzle_publish_failed: string
    puzzle_publish_retry: string
    puzzle_submitted_review: string
    puzzle_like_failed: string
    puzzle_unlike_failed: string
    puzzle_report_reason_porn: string
    puzzle_report_reason_violence: string
    puzzle_report_reason_politics: string
    puzzle_report_reason_illegal: string
    puzzle_report_reason_infringement: string
    puzzle_report_reason_other: string
    puzzle_clues_empty_hint: string
    puzzle_clues_no_eliminated: string
    // case file drawer
    casefile_title: string
    casefile_subtitle: string
    casefile_complete: string
    casefile_in_progress: string
    casefile_investigation: string
    casefile_goals: string
    casefile_goals_count: string
    casefile_confirmed_yes: string
    casefile_eliminated_no: string
    /** 谜面折叠区标题：解决以下问题完成谜题 */
    puzzle_solve_hint: string
    /** 默认关键线索：凶手、手法、动机（多语言） */
    puzzle_keypoint_murderer: string
    puzzle_keypoint_method: string
    puzzle_keypoint_motive: string
    puzzle_goals_hint: string
    puzzle_quirky_hint: string
    /** 真相大白卡片 */
    puzzle_truth_revealed_title: string
    puzzle_truth_revealed_subtitle: string
    puzzle_truth_view_full: string
    puzzle_truth_answer_label: string
    puzzle_truth_back_list: string
    next_puzzle_title: string
    next_puzzle_hook_label: string
    next_puzzle_start: string
    next_puzzle_start_countdown: string
    next_puzzle_ai_generate: string
    next_puzzle_loading: string
    next_puzzle_empty: string
    giveup_title: string
    giveup_desc: string
    giveup_switch_puzzle: string
    giveup_keep_playing: string
    giveup_leave: string
    giveup_switch_empty: string
    giveup_switching: string
    giveup_answer_title: string
    giveup_answer_subtitle: string
    giveup_stat_solved: string
    giveup_stat_rounds: string
    giveup_reveal_free: string
    giveup_free_daily_note: string
    giveup_reveal_prefix: string
    giveup_deducted_prefix: string
    giveup_deducted_suffix: string
    giveup_answer_label: string
    giveup_answer_closure: string
    giveup_answer_done: string
    giveup_answer_failed: string
    giveup_reward_label: string
    giveup_reveal_action: string
    giveup_leave_mute: string
    // chat page
    chat_load_failed: string
    chat_send_failed: string
    chat_loading: string
    chat_not_found: string
    chat_ended: string
    chat_enter_hint: string
    chat_progress: string
    chat_stat_questions: string
    chat_stat_duration: string
    chat_stat_goals: string
    chat_stat_likes: string
    chat_answer_yes: string
    chat_answer_no: string
    chat_answer_both: string
    chat_answer_unrelated: string
    chat_case_closed: string
    // puzzle_create
    puzzle_create_title: string
    puzzle_create_ai_tab: string
    puzzle_create_manual_tab: string
    puzzle_create_ai_title: string
    puzzle_create_ai_description: string
    puzzle_create_ai_button: string
    puzzle_create_generating: string
    puzzle_create_title_label: string
    puzzle_create_title_placeholder: string
    puzzle_create_soup_label: string
    puzzle_create_soup_placeholder: string
    puzzle_create_truth_label: string
    puzzle_create_truth_placeholder: string
    puzzle_create_truth_hidden: string
    puzzle_create_show_truth: string
    puzzle_create_show_truth_dialog_title: string
    puzzle_create_show_truth_dialog_description: string
    puzzle_create_show_truth_confirm: string
    puzzle_create_challenge: string
    puzzle_create_try_self: string
    puzzle_create_regenerate: string
    puzzle_create_publish: string
    puzzle_create_ai_fill: string
    puzzle_create_ai_fill_free: string
    puzzle_create_ai_fill_failed: string
    puzzle_create_ai_mode_title: string
    puzzle_create_ai_mode_fill: string
    puzzle_create_ai_mode_fill_desc: string
    puzzle_create_ai_mode_optimize: string
    puzzle_create_ai_mode_optimize_desc: string
    puzzle_create_ai_extra_prompt: string
    puzzle_create_ai_extra_prompt_placeholder: string
    lantern_brewing: string
    lantern_drag_hint: string
    lantern_waiting: string
    lantern_ready: string
    lantern_gen_failed: string
    lantern_back: string
    puzzle_create_targets_label: string
    puzzle_create_add_target: string
    puzzle_create_origin_label: string
    puzzle_create_origin_original: string
    puzzle_create_origin_repost: string
    puzzle_create_author_name: string
    puzzle_create_author_name_placeholder: string
    puzzle_create_creating: string
    puzzle_create_edit_title: string
    puzzle_create_save_changes: string
    puzzle_create_publish_success_title: string
    puzzle_create_publish_success_message: string
    puzzle_create_publish_success_try: string
    puzzle_create_publish_success_back: string
    puzzle_create_publish_failed: string
    puzzle_create_difficulty: string
    puzzle_create_tags: string
    puzzle_create_tags_hint: string
    puzzle_create_preview: string
    puzzle_create_collapse: string
    puzzle_create_expand: string
    puzzle_create_ready: string
    puzzle_create_incomplete: string
    // puzzles_list
    puzzle_list_title: string
    puzzle_list_empty_title: string
    puzzle_list_empty_description: string
    puzzle_list_empty_button: string
    puzzle_list_active: string
    puzzle_list_completed: string
    puzzle_list_delete_success: string
    puzzle_list_delete_failed: string
    puzzle_delete_confirm_title: string
    puzzle_delete_confirm_description: string
    puzzle_delete_confirm_action: string
    puzzle_list_loading: string
    // recharge
    recharge_title: string
    recharge_insufficient_balance: string
    recharge_balance: string
    recharge_balance_label: string
    recharge_select_amount: string
    recharge_selected: string
    recharge_confirm: string
    recharge_processing: string
    recharge_confirm_amount: string
    recharge_subscribed: string
    recharge_back: string
    recharge_launching_payment: string
    recharge_verifying: string
    recharge_subscription_section: string
    recharge_sp_unit: string
    recharge_sub_name: string
    recharge_sub_desc: string
    recharge_sub_period: string
    recharge_sub_perk1: string
    recharge_sub_perk2: string
    recharge_basic_name: string
    recharge_basic_desc: string
    recharge_basic_perk: string
    recharge_basic_price: string
    profile_check_in_success_lite: string
    recharge_desc_300: string
    recharge_desc_900: string
    recharge_desc_1500: string
    recharge_desc_3000: string
    // discover
    discover_title: string
    discover_pickup_title: string
    discover_new: string
    discover_latest: string
    discover_hot_today: string
    discover_hot_week: string
    discover_login_warning: string
    discover_loading: string
    // profile
    profile_title: string
    profile_not_logged_in: string
    profile_not_logged_in_description: string
    profile_login_now: string
    profile_avatar_alt: string
    profile_coins: string
    coins_unit: string
    profile_recharge: string
    profile_check_in: string
    profile_check_in_success: string
    profile_check_in_already: string
    profile_network_error: string
    profile_tab_created: string
    profile_tab_liked: string
    profile_empty_created_title: string
    profile_empty_created_description: string
    profile_create_puzzle: string
    profile_empty_liked_title: string
    profile_empty_liked_description: string
    profile_go_discover: string
    profile_edit_nickname_title: string
    profile_edit_nickname_description: string
    profile_edit_nickname_placeholder: string
    profile_edit_nickname_max: string
    profile_edit_nickname_saved: string
    profile_edit_nickname_failed: string
    profile_edit_nickname_cancel: string
    profile_edit_nickname_save: string
    profile_avatar_upload_error: string
    profile_avatar_size_error: string
    profile_avatar_updated: string
    // puzzle-card
    puzzle_card_publish: string
    puzzle_card_reviewing: string
    puzzle_card_rejected: string
    puzzle_card_completed: string
    puzzle_card_publish_failed: string
    puzzle_card_publish_retry: string
    puzzle_card_submitted_review: string
    puzzle_card_original: string
    puzzle_card_repost: string
    puzzle_card_anonymous: string
    puzzle_card_author_default: string
    puzzle_card_new_this_week: string
    puzzle_card_solved_count: string
    // settings
    settings_title: string
    settings_language: string
    settings_privacy_policy: string
    settings_terms_of_service: string
    settings_logout: string
    settings_logout_confirm_title: string
    settings_logout_confirm_description: string
    settings_logout_confirm_cancel: string
    settings_logout_confirm_action: string
    settings_logout_success: string
    settings_logout_failed: string
    settings_discord_title: string
    settings_discord_desc: string
    settings_discord_join: string
    settings_delete_account: string
    settings_delete_account_confirm_title: string
    settings_delete_account_confirm_description: string
    settings_delete_account_confirm_cancel: string
    settings_delete_account_confirm_action: string
    settings_delete_account_success: string
    settings_delete_account_failed: string
    settings_delete_account_network_error: string
    settings_theme: string
    settings_theme_light: string
    settings_theme_dark: string
    settings_preferences: string
    topbar_login_account: string
    topbar_login_bonus: string
    topbar_community_join: string
    topbar_community_qq: string
    topbar_community_pending: string
    settings_section_appearance: string
    settings_section_community: string
    settings_section_account: string
    settings_redeem_code: string
    settings_redeem_code_desc: string
    settings_redeem_code_placeholder: string
    settings_redeem_code_action: string
    settings_redeem_code_redeeming: string
    settings_redeem_code_success: string
    settings_redeem_code_invalid: string
    settings_redeem_code_already_redeemed: string
    settings_redeem_code_network_error: string
    login_account_deletion_title: string
    login_account_deletion_description: string
    login_account_deletion_continue: string
    login_account_deletion_cancel: string
    login_account_deletion_revoke_success: string
    login_account_deletion_revoke_failed: string
    login_account_deletion_network_error: string
    // login tutorial
    tutorial_welcome: string
    tutorial_ask_familiar: string
    tutorial_response_yes: string
    tutorial_response_no: string
    tutorial_intro_demo: string
    tutorial_congrats: string
    tutorial_puzzle_demo: string
    tutorial_option_1: string
    tutorial_option_2: string
    tutorial_option_3: string
    tutorial_option_4: string
    tutorial_option_5: string
    tutorial_got_it: string
    tutorial_answer_yes: string
    tutorial_answer_no: string
    // themes
    theme_label: string
    theme_all: string
    theme_honkaku: string
    theme_henkaku: string
    theme_suspense: string
    theme_casual: string
    theme_hardcore: string
    theme_horror: string
    theme_heartwarming: string
    theme_quirky: string
    // discover sort
    discover_sort_latest: string
    discover_sort_hot_today: string
    discover_sort_hot_week: string
    // discover filter & sort (web)
    discover_filter_all: string
    discover_filter_hot: string
    discover_filter_latest: string
    discover_difficulty_easy: string
    discover_difficulty_medium: string
    discover_difficulty_hard: string
    discover_sortby_composite: string
    discover_sortby_newest: string
    discover_sortby_most_liked: string
    discover_sortby_most_played: string
    discover_no_result: string
    discover_puzzle_count: string
    // navigation
    nav_puzzles: string
    nav_discover: string
    nav_profile: string
    nav_create: string
    nav_recharge: string
    nav_settings: string
    nav_my_puzzles: string
    sidebar_investigation: string
    sidebar_case_files: string
    sidebar_account: string
    sidebar_tagline: string
}

export const zhCNTextData: TextDataType = {
    theme_quirky: "搞怪",
    puzzle_quirky_hint: "搞怪类谜题可能需要发挥想象~请尽情推理吧！",
    login_title: "欢迎来到境谜。",
    login_subtitle: "输入邮箱密码以登录，如果账户不存在，将直接注册一个账户。",
    login_email_title: "邮箱",
    login_email_continue: "继续",
    login_email_miss_toast: "请先填写邮箱",
    login_otp_miss_toast: "请先填写验证码",
    login_email_wrong_toast: "请检查邮箱地址格式",
    login_otp_send_toast: "验证码已发送，请于邮箱查收",
    login_loading: "正在登录...",
    login_fail_toast: "登录失败，请重试",
    login_network_error: "网络连接失败，请检查网络设置后重试",
    login_otp_title: "验证码",
    login_otp_continue: "登录",
    login_get_otp_button: "获得验证码",
    login_otp_cd: "秒",
    login_quick_use: "快速游玩",
    login_guest: "先逛逛看",
    login_divider: "或",
    login_email_placeholder: "m@example.com",
    login_as_apple: "以 Apple 继续",
    login_as_google: "以 Google 继续",
    login_tips: "首次登录时将自动注册账号。\n继续使用代表您同意用户协议和隐私政策。",
    login_sign_in: "登录",
    login_sign_up: "注册（立即获得50积分！）",
    login_welcome_back: "欢迎回来，",
    login_hero_tagline: "每个谜题背后，都有一个等待揭晓的真相",
    login_hero_desc: "AI 驱动的推理解谜。\n提问，探索，揭开真相。",
    login_brand: "境 谜",
    login_access_terminal: "进入终端",
    app_play: "游玩",
    app_share: "分享",
    // puzzle_chat
    puzzle_soup_label: "谜题",
    puzzle_publish: "发布",
    puzzle_reviewing: "审核中",
    puzzle_like: "点赞",
    puzzle_input_placeholder: "输入问题或猜测...",
    puzzle_report_title: "举报谜题",
    puzzle_report_description: "请选择举报原因，并填写详细信息",
    puzzle_report_reason_label: "举报原因",
    puzzle_report_extra_label: "补充说明（可选）",
    puzzle_report_extra_placeholder: "请详细描述举报原因...",
    puzzle_report_cancel: "取消",
    puzzle_report_submit: "确认",
    puzzle_report_submitting: "提交中...",
    puzzle_report_confirm: "确认",
    puzzle_report_success: "举报提交成功，我们将尽快处理！",
    puzzle_publish_failed: "发布失败，请重试",
    puzzle_publish_retry: "发布失败，请重试",
    puzzle_submitted_review: "已提交审核",
    puzzle_like_failed: "点赞失败，请重试",
    puzzle_unlike_failed: "取消点赞失败，请重试",
    puzzle_report_reason_porn: "色情",
    puzzle_report_reason_violence: "过度夸张的暴力内容",
    puzzle_report_reason_politics: "时政信息",
    puzzle_report_reason_illegal: "非法内容",
    puzzle_report_reason_infringement: "侵权",
    puzzle_report_reason_other: "其它",
    puzzle_clues_empty_hint: "进行提问获取线索吧。",
    puzzle_clues_no_eliminated: "暂无排除的情报",
    casefile_title: "谜题",
    casefile_subtitle: "Case File",
    casefile_complete: "已完成",
    casefile_in_progress: "调查中",
    casefile_investigation: "调查进展",
    casefile_goals: "目标",
    casefile_goals_count: "{achieved} / {total}",
    casefile_confirmed_yes: "已确认 (YES)",
    casefile_eliminated_no: "已排除 (NO)",
    puzzle_solve_hint: "解决以下问题完成谜题",
    puzzle_keypoint_murderer: "凶手",
    puzzle_keypoint_method: "手法",
    puzzle_keypoint_motive: "动机",
    puzzle_goals_hint: "解开所有关键目标，即可获得谜底",
    puzzle_truth_revealed_title: "真相大白",
    puzzle_truth_revealed_subtitle: "你已解开所有谜团！",
    puzzle_truth_view_full: "查看完整谜底",
    puzzle_truth_answer_label: "答案:",
    puzzle_truth_back_list: "返回列表",
    next_puzzle_title: "下一场谜案",
    next_puzzle_hook_label: "汤面抢先看",
    next_puzzle_start: "开始下一题",
    next_puzzle_start_countdown: "开始下一题 ({s})",
    next_puzzle_ai_generate: "让 AI 出一道新题",
    next_puzzle_loading: "正在寻找下一场谜案…",
    next_puzzle_empty: "暂时没有更多新谜案，让 AI 出一道吧",
    giveup_title: "卡住了？",
    giveup_desc: "别急着走，先试试这些",
    giveup_switch_puzzle: "换一道试试",
    giveup_keep_playing: "返回继续玩",
    giveup_switch_empty: "没有更合适的题了",
    giveup_switching: "正在为你换一道…",
    giveup_leave: "离开",
    giveup_answer_title: "要直接看看答案吗？",
    giveup_answer_subtitle: "有时候，并不是你的推理出了问题",
    giveup_stat_solved: "已解开目标",
    giveup_stat_rounds: "提问轮次",
    giveup_reveal_free: "免费查看答案",
    giveup_free_daily_note: "今日首次免费",
    giveup_reveal_prefix: "查看答案需",
    giveup_deducted_prefix: "优惠后扣除",
    giveup_deducted_suffix: " SP",
    giveup_answer_label: "真相",
    giveup_answer_closure: "事情的真相是这样的",
    giveup_answer_done: "知道了",
    giveup_answer_failed: "无法查看答案，请稍后重试",
    giveup_reward_label: "已节省",
    giveup_reveal_action: "查看答案",
    giveup_leave_mute: "离开（今天不再询问）",
    // chat page
    chat_load_failed: "加载对话失败",
    chat_send_failed: "发送失败，请重试",
    chat_loading: "正在加载案件...",
    chat_not_found: "案件未找到",
    chat_ended: "对话已结束",
    chat_enter_hint: "按 Enter 发送，Shift + Enter 换行",
    chat_progress: "进度",
    chat_stat_questions: "提问",
    chat_stat_duration: "时长",
    chat_stat_goals: "目标",
    chat_stat_likes: "喜欢",
    chat_answer_yes: "是",
    chat_answer_no: "否",
    chat_answer_both: "是也不是",
    chat_answer_unrelated: "无关",
    chat_case_closed: "案件结案",
    // puzzle_create
    puzzle_create_title: "新谜题",
    puzzle_create_ai_tab: "AI出题",
    puzzle_create_manual_tab: "自己创建谜题",
    puzzle_create_ai_title: "调查出一场谜题",
    puzzle_create_ai_description: "AI协探将为你调查获得一道原创海龟汤谜题。选择偏好主题，点亮煤油灯进行调查，探索黑暗中的故事。",
    puzzle_create_ai_button: "开始追查",
    puzzle_create_generating: "生成中...",
    puzzle_create_title_label: "谜题标题",
    puzzle_create_title_placeholder: "给你的谜题起个名字",
    puzzle_create_soup_label: "谜题",
    puzzle_create_soup_placeholder: "描述谜题的初始情景（越简洁越有悬念越好）",
    puzzle_create_truth_label: "谜底",
    puzzle_create_truth_placeholder: "谜题的真相（仅创作者和已解出用户可见）",
    puzzle_create_truth_hidden: "点击\"显示谜底\"查看谜题答案",
    puzzle_create_show_truth: "显示谜底",
    puzzle_create_show_truth_dialog_title: "确认查看谜底",
    puzzle_create_show_truth_dialog_description: "查看谜底后，你将无法再以挑战者的身份体验这个谜题。确定要查看吗？",
    puzzle_create_show_truth_confirm: "确认查看",
    puzzle_create_challenge: "挑战试试",
    puzzle_create_try_self: "自己试试",
    puzzle_create_regenerate: "重新出题",
    puzzle_create_publish: "提交谜题",
    puzzle_create_ai_fill: "智能新建",
    puzzle_create_ai_fill_free: "本次免费",
    puzzle_create_ai_fill_failed: "AI生成失败",
    puzzle_create_ai_mode_title: "智能创建",
    puzzle_create_ai_mode_fill: "自动补充",
    puzzle_create_ai_mode_fill_desc: "仅补充未填写的内容",
    puzzle_create_ai_mode_optimize: "完全优化",
    puzzle_create_ai_mode_optimize_desc: "基于已有内容重新优化",
    puzzle_create_ai_extra_prompt: "额外提示（可选）",
    puzzle_create_ai_extra_prompt_placeholder: "例如：更恐怖一些、加入校园背景...",
    lantern_brewing: "正在调查谜题",
    lantern_drag_hint: "拖动光源 · 探索线索",
    lantern_waiting: "等待谜题准备中…",
    lantern_ready: "谜题准备完成",
    lantern_gen_failed: "生成失败\n请稍后重试",
    lantern_back: "返回",
    puzzle_create_targets_label: "目标",
    puzzle_create_add_target: "添加目标",
    puzzle_create_origin_label: "来源",
    puzzle_create_origin_original: "原创",
    puzzle_create_origin_repost: "转载",
    puzzle_create_author_name: "原作者名",
    puzzle_create_author_name_placeholder: "请输入原作者名称",
    puzzle_create_creating: "提交中...",
    puzzle_create_edit_title: "编辑谜题",
    puzzle_create_save_changes: "保存修改",
    puzzle_create_publish_success_title: "提交成功",
    puzzle_create_publish_success_message: "谜题提交成功，等待审核",
    puzzle_create_publish_success_try: "现在试试",
    puzzle_create_publish_success_back: "返回首页",
    puzzle_create_publish_failed: "提交失败，请重试",
    puzzle_create_difficulty: "难度等级",
    puzzle_create_tags: "标签",
    puzzle_create_tags_hint: "可选，最多3个",
    puzzle_create_preview: "预览",
    puzzle_create_collapse: "收起",
    puzzle_create_expand: "展开预览",
    puzzle_create_ready: "所有必填项已完成，可以发布了",
    puzzle_create_incomplete: "请完成所有必填项",
    // puzzles_list
    puzzle_list_title: "进行中谜题",
    puzzle_list_empty_title: "还没有进行过解谜",
    puzzle_list_empty_description: "选择一个谜题开始解谜！",
    puzzle_list_empty_button: "开始解谜",
    puzzle_list_active: "正在进行",
    puzzle_list_completed: "已完成",
    puzzle_list_delete_success: "删除成功",
    puzzle_list_delete_failed: "删除失败",
    puzzle_delete_confirm_title: "确认删除谜题",
    puzzle_delete_confirm_description: "该谜题会从你的列表和公开区域隐藏。Web 端暂不支持恢复此操作。",
    puzzle_delete_confirm_action: "删除谜题",
    puzzle_list_loading: "正在翻阅卷宗...",
    // recharge
    recharge_title: "充值中心",
    recharge_insufficient_balance: "余额不足，请先充值",
    recharge_balance: "当前余额",
    recharge_balance_label: "境谜点",
    recharge_select_amount: "选择充值金额",
    recharge_selected: "已选择",
    recharge_confirm: "确认充值",
    recharge_processing: "处理中...",
    recharge_confirm_amount: "确认充值",
    recharge_subscribed: "订阅中",
    recharge_back: "返回",
    recharge_launching_payment: "正在处理支付...",
    recharge_verifying: "正在确认购买结果...",
    recharge_subscription_section: "当前订阅",
    recharge_sp_unit: "境谜点",
    recharge_sub_name: "境谜侦探Lite",
    recharge_sub_desc: "每月600境谜点+签到加成",
    recharge_sub_period: "月",
    recharge_sub_perk1: "每月600境谜点",
    recharge_sub_perk2: "每日签到7境谜点",
    recharge_basic_name: "境谜侦探Basic",
    recharge_basic_desc: "免费基础档",
    recharge_basic_perk: "签到 2SP/日",
    recharge_basic_price: "免费",
    profile_check_in_success_lite: "签到获得7境谜点（Lite权益生效）",
    recharge_desc_300: "尝鲜体验",
    recharge_desc_900: "轻度解谜",
    recharge_desc_1500: "推理达人",
    recharge_desc_3000: "侦探畅玩",
    // discover
    discover_title: "发现谜题",
    discover_pickup_title: "精选推荐",
    discover_new: "新建",
    discover_latest: "最新",
    discover_hot_today: "今日最热",
    discover_hot_week: "本周最热",
    discover_login_warning: "请先登录~",
    discover_loading: "正在搜寻线索...",
    // profile
    profile_title: "个人中心",
    profile_not_logged_in: "未登录",
    profile_not_logged_in_description: "登录后可查看个人数据、保存谜题进度",
    profile_login_now: "立即登录",
    profile_avatar_alt: "用户头像",
    profile_coins: "境谜点",
    coins_unit: "境谜点（SP）",
    profile_recharge: "充值",
    profile_check_in: "签到",
    profile_check_in_success: "签到获得2境谜点",
    profile_check_in_already: "今日已签到",
    profile_network_error: "网络问题",
    profile_tab_created: "我创建的",
    profile_tab_liked: "我喜欢的",
    profile_empty_created_title: "还没有创建的谜题",
    profile_empty_created_description: "创建你的第一个谜题，与大家分享吧",
    profile_create_puzzle: "创建谜题",
    profile_empty_liked_title: "还没有喜欢的谜题",
    profile_empty_liked_description: "去发现界面探索更多有趣的谜题吧",
    profile_go_discover: "去发现",
    profile_edit_nickname_title: "修改昵称",
    profile_edit_nickname_description: "请输入新的昵称（最多12个字符）",
    profile_edit_nickname_placeholder: "请输入昵称",
    profile_edit_nickname_max: "昵称不能超过12个字符",
    profile_edit_nickname_saved: "昵称已更新",
    profile_edit_nickname_failed: "更新昵称失败，已恢复原昵称",
    profile_edit_nickname_cancel: "取消",
    profile_edit_nickname_save: "保存",
    profile_avatar_upload_error: "请选择图片文件",
    profile_avatar_size_error: "图片大小不能超过 5MB",
    profile_avatar_updated: "头像已更新",
    // puzzle-card
    puzzle_card_publish: "发布",
    puzzle_card_reviewing: "审核中",
    puzzle_card_rejected: "违规",
    puzzle_card_completed: "已完成",
    puzzle_card_publish_failed: "发布失败，请重试",
    puzzle_card_publish_retry: "发布失败，请重试",
    puzzle_card_submitted_review: "已提交审核",
    puzzle_card_original: "原创",
    puzzle_card_repost: "转载",
    puzzle_card_anonymous: "匿名",
    puzzle_card_author_default: "谜探",
    puzzle_card_new_this_week: "本周新谜",
    puzzle_card_solved_count: "人解过",
    // settings
    settings_title: "设置",
    settings_language: "语言设置",
    settings_privacy_policy: "隐私政策",
    settings_terms_of_service: "用户协议",
    settings_logout: "退出登录",
    settings_logout_confirm_title: "确认退出登录",
    settings_logout_confirm_description: "退出登录后，您将无法访问个人数据，需要重新登录。",
    settings_logout_confirm_cancel: "取消",
    settings_logout_confirm_action: "确认退出",
    settings_logout_success: "已退出登录",
    settings_discord_title: "加入 Discord 社区",
    settings_discord_desc: "随时反馈交流，获取最新消息",
    settings_discord_join: "加入",
    settings_logout_failed: "退出登录失败",
    settings_delete_account: "删除账号",
    settings_delete_account_confirm_title: "确认删除账号",
    settings_delete_account_confirm_description: "删除账号，关联的所有内容（账号资料、包括发布的谜题数据）均会被删除。删除操作将由客服人员人工审核和确认执行，预计在14个工作日内完成，执行时会邮件通知。再次过程中可以随时通过重新登录来取消账号删除。",
    settings_delete_account_confirm_cancel: "取消",
    settings_delete_account_confirm_action: "确认删除",
    settings_delete_account_success: "删除账号申请已提交",
    settings_delete_account_failed: "提交删除账号申请失败",
    settings_delete_account_network_error: "遇到网络问题，请再次尝试",
    settings_theme: "主题",
    settings_theme_light: "浅色",
    settings_theme_dark: "深色",
    settings_preferences: "设置与偏好",
    topbar_login_account: "登录账号",
    topbar_login_bonus: "即刻开启自由推理",
    topbar_community_join: "加入社区",
    topbar_community_qq: "QQ群",
    topbar_community_pending: "群链接待配置",
    settings_section_appearance: "外观",
    settings_section_community: "社区",
    settings_section_account: "账号",
    settings_redeem_code: "兑换码",
    settings_redeem_code_desc: "输入活动或社区兑换码，领取 SP",
    settings_redeem_code_placeholder: "请输入兑换码",
    settings_redeem_code_action: "兑换",
    settings_redeem_code_redeeming: "兑换中...",
    settings_redeem_code_success: "兑换成功，获得 {amount} SP",
    settings_redeem_code_invalid: "兑换码无效或已过期",
    settings_redeem_code_already_redeemed: "你已兑换过此兑换码",
    settings_redeem_code_network_error: "兑换失败，请稍后重试",
    login_account_deletion_title: "账号删除申请",
    login_account_deletion_description: "当前帐号已经提交删除账号申请，点击“继续”以继续登录并撤销账号删除请求。",
    login_account_deletion_continue: "继续",
    login_account_deletion_cancel: "取消",
    login_account_deletion_revoke_success: "已撤销账号删除申请",
    login_account_deletion_revoke_failed: "撤销账号删除申请失败",
    login_account_deletion_network_error: "遇到网络问题，请重新登录",
    // login tutorial
    tutorial_welcome: "欢迎来到境谜，AI赋能的情境谜题。",
    tutorial_ask_familiar: "在开始之前，想先请问您：\n您是否熟悉 海龟汤/情境解谜 游戏？",
    tutorial_response_yes: "好的，让我直接为您快速介绍如何使用本软件。",
    tutorial_response_no: "好的，海龟汤/情境解谜游戏，正是如刚才这样，由一方根据'谜面'提问，另一方根据'真相'回答'是'、'不是'或'与此无关'，直到真相被揭晓的游戏。",
    tutorial_intro_demo: "接下来，我会给你一个谜面，请你选择你想问的问题，我将回答。由于是演示教学，我会直接为您提供选项；实际游玩时，您可任意打字提问你想问的内容。",
    tutorial_congrats: "恭喜你已经基本了解了海龟汤如何游玩！现在，登录账号，一起进行更多的情境解谜吧！让我再次致敬：",
    tutorial_puzzle_demo: "一个盲人进入一家餐厅，他点了一份海龟汤。在品尝一口后，他突然痛苦悲鸣，走出餐厅自尽了。请猜出背后的真相是什么？",
    tutorial_option_1: "他是被下毒了吗？",
    tutorial_option_2: "他是回忆起了什么吗？",
    tutorial_option_3: "他是否曾和同伴被困海上荒岛几乎饿死时，喝过同伴给的'海龟汤'？",
    tutorial_option_4: "他是想起养过的海龟了吗？",
    tutorial_option_5: "他是不是意识到，那次喝到的'海龟汤'，其实是同伴割肉做成的，所以他才坚持到获救，而同伴不幸去世。",
    tutorial_got_it: "好的",
    tutorial_answer_yes: "是的",
    tutorial_answer_no: "不是",
    // navigation
    // themes
    theme_label: "主题",
    theme_all: "全部",
    theme_honkaku: "本格",
    theme_henkaku: "变格",
    theme_suspense: "悬疑",
    theme_casual: "轻松",
    theme_hardcore: "硬核",
    theme_horror: "微恐",
    theme_heartwarming: "温情",
    // discover sort
    discover_sort_latest: "最新",
    discover_sort_hot_today: "今日最热",
    discover_sort_hot_week: "本周最热",
    // discover filter & sort (web)
    discover_filter_all: "全部",
    discover_filter_hot: "最热",
    discover_filter_latest: "最新",
    discover_difficulty_easy: "简单",
    discover_difficulty_medium: "中等",
    discover_difficulty_hard: "困难",
    discover_sortby_composite: "综合排序",
    discover_sortby_newest: "最新发布",
    discover_sortby_most_liked: "最多点赞",
    discover_sortby_most_played: "最多挑战",
    discover_no_result: "没有找到符合条件的谜题",
    discover_puzzle_count: "道谜题",
    nav_puzzles: "谜题",
    nav_discover: "发现",
    nav_profile: "我的",
    nav_create: "新谜题",
    nav_recharge: "充值中心",
    nav_settings: "设置",
    nav_my_puzzles: "进行中谜题",
    sidebar_investigation: "谜题",
    sidebar_case_files: "调查",
    sidebar_account: "账户",
    sidebar_tagline: "情境谜题推理"
};

// 繁体中文
export const zhTWTextData: TextDataType = {
    theme_quirky: "搞怪",
    puzzle_quirky_hint: "搞怪類謎題可能需要發揮想像～請盡情推理吧！",
    login_title: "歡迎來到境謎。",
    login_subtitle: "輸入郵箱密碼以登錄，如果賬戶不存在，將直接註冊一個賬戶。",
    login_email_title: "郵箱",
    login_email_continue: "繼續",
    login_email_miss_toast: "請先填寫郵箱",
    login_otp_miss_toast: "請先填寫驗證碼",
    login_email_wrong_toast: "請檢查郵箱地址格式",
    login_otp_send_toast: "驗證碼已發送，請於郵箱查收",
    login_loading: "正在登入...",
    login_fail_toast: "登入失敗，請重試",
    login_network_error: "網路連線失敗，請檢查網路設定後重試",
    login_otp_title: "驗證碼",
    login_otp_continue: "登錄",
    login_get_otp_button: "獲得驗證碼",
    login_otp_cd: "秒",
    login_quick_use: "快速遊玩",
    login_guest: "先逛逛看",
    login_divider: "或",
    login_email_placeholder: "m@example.com",
    login_as_apple: "以 Apple 繼續",
    login_as_google: "以 Google 繼續",
    login_tips: "首次登錄時將自動註冊賬號。\n繼續使用代表您同意用戶協議和隱私政策。",
    login_sign_in: "登錄",
    login_sign_up: "註冊（立即獲得50積分！）",
    login_welcome_back: "歡迎回來，",
    login_hero_tagline: "每個謎題背後，都有一個等待揭曉的真相",
    login_hero_desc: "AI 驅動的推理解謎。\n提問，探索，揭開真相。",
    login_brand: "境 謎",
    login_access_terminal: "進入終端",
    app_play: "遊玩",
    app_share: "分享",
    // puzzle_chat
    puzzle_soup_label: "謎題",
    puzzle_publish: "發布",
    puzzle_reviewing: "審核中",
    puzzle_like: "點讚",
    puzzle_input_placeholder: "輸入問題或猜測...",
    puzzle_report_title: "舉報謎題",
    puzzle_report_description: "請選擇舉報原因，並填寫詳細信息",
    puzzle_report_reason_label: "舉報原因",
    puzzle_report_extra_label: "補充說明（可選）",
    puzzle_report_extra_placeholder: "請詳細描述舉報原因...",
    puzzle_report_cancel: "取消",
    puzzle_report_submit: "確認",
    puzzle_report_submitting: "提交中...",
    puzzle_report_confirm: "確認",
    puzzle_report_success: "舉報提交成功，我們將盡快處理！",
    puzzle_publish_failed: "發布失敗，請重試",
    puzzle_publish_retry: "發布失敗，請重試",
    puzzle_submitted_review: "已提交審核",
    puzzle_like_failed: "點讚失敗，請重試",
    puzzle_unlike_failed: "取消點讚失敗，請重試",
    puzzle_report_reason_porn: "色情",
    puzzle_report_reason_violence: "過度誇張的暴力內容",
    puzzle_report_reason_politics: "時政信息",
    puzzle_report_reason_illegal: "非法內容",
    puzzle_report_reason_infringement: "侵權",
    puzzle_report_reason_other: "其它",
    puzzle_clues_empty_hint: "進行提問獲取線索吧。",
    puzzle_clues_no_eliminated: "暫無排除的情報",
    casefile_title: "謎題",
    casefile_subtitle: "Case File",
    casefile_complete: "已完成",
    casefile_in_progress: "調查中",
    casefile_investigation: "調查進展",
    casefile_goals: "目標",
    casefile_goals_count: "{achieved} / {total}",
    casefile_confirmed_yes: "已確認 (YES)",
    casefile_eliminated_no: "已排除 (NO)",
    puzzle_solve_hint: "解決以下問題完成謎題",
    puzzle_keypoint_murderer: "兇手",
    puzzle_keypoint_method: "手法",
    puzzle_keypoint_motive: "動機",
    puzzle_goals_hint: "解開所有關鍵目標，即可獲得謎底",
    puzzle_truth_revealed_title: "真相大白",
    puzzle_truth_revealed_subtitle: "你已解開所有謎團！",
    puzzle_truth_view_full: "查看完整謎底",
    puzzle_truth_answer_label: "答案:",
    puzzle_truth_back_list: "返回列表",
    next_puzzle_title: "下一場謎案",
    next_puzzle_hook_label: "湯面搶先看",
    next_puzzle_start: "開始下一題",
    next_puzzle_start_countdown: "開始下一題 ({s})",
    next_puzzle_ai_generate: "讓 AI 出一道新題",
    next_puzzle_loading: "正在尋找下一場謎案…",
    next_puzzle_empty: "暫時沒有更多新謎案，讓 AI 出一道吧",
    giveup_title: "卡住了？",
    giveup_desc: "別急著走，先試試這些",
    giveup_switch_puzzle: "換一道試試",
    giveup_keep_playing: "返回繼續玩",
    giveup_switch_empty: "沒有更合適的題了",
    giveup_switching: "正在為你換一道…",
    giveup_leave: "離開",
    giveup_answer_title: "要直接看看答案嗎？",
    giveup_answer_subtitle: "有時候，並不是你的推理出了問題",
    giveup_stat_solved: "已解開目標",
    giveup_stat_rounds: "提問輪次",
    giveup_reveal_free: "免費查看答案",
    giveup_free_daily_note: "今日首次免費",
    giveup_reveal_prefix: "查看答案需",
    giveup_deducted_prefix: "優惠後扣除",
    giveup_deducted_suffix: " SP",
    giveup_answer_label: "真相",
    giveup_answer_closure: "事情的真相是這樣的",
    giveup_answer_done: "知道了",
    giveup_answer_failed: "無法查看答案，請稍後重試",
    giveup_reward_label: "已節省",
    giveup_reveal_action: "查看答案",
    giveup_leave_mute: "離開（今天不再詢問）",
    // chat page
    chat_load_failed: "載入對話失敗",
    chat_send_failed: "發送失敗，請重試",
    chat_loading: "正在載入案件...",
    chat_not_found: "案件未找到",
    chat_ended: "對話已結束",
    chat_enter_hint: "按 Enter 發送，Shift + Enter 換行",
    chat_progress: "進度",
    chat_stat_questions: "提問",
    chat_stat_duration: "時長",
    chat_stat_goals: "目標",
    chat_stat_likes: "喜歡",
    chat_answer_yes: "是",
    chat_answer_no: "否",
    chat_answer_both: "是也不是",
    chat_answer_unrelated: "無關",
    chat_case_closed: "案件結案",
    // puzzle_create
    puzzle_create_title: "新謎題",
    puzzle_create_ai_tab: "AI出題",
    puzzle_create_manual_tab: "自己創建謎題",
    puzzle_create_ai_title: "調查出一場謎題",
    puzzle_create_ai_description: "AI協探將為你調查獲得一道原創海龜湯謎題。選擇偏好主題，點亮煤油燈進行調查，探索黑暗中的故事。",
    puzzle_create_ai_button: "開始追查",
    puzzle_create_generating: "生成中...",
    puzzle_create_title_label: "謎題標題",
    puzzle_create_title_placeholder: "給你的謎題起個名字",
    puzzle_create_soup_label: "謎題",
    puzzle_create_soup_placeholder: "描述謎題的初始情景（越簡潔越有懸念越好）",
    puzzle_create_truth_label: "謎底",
    puzzle_create_truth_placeholder: "謎題的真相（僅創作者和已解出用戶可見）",
    puzzle_create_truth_hidden: "點擊\"顯示謎底\"查看謎題答案",
    puzzle_create_show_truth: "顯示謎底",
    puzzle_create_show_truth_dialog_title: "確認查看謎底",
    puzzle_create_show_truth_dialog_description: "查看謎底後，你將無法再以挑戰者的身份體驗這個謎題。確定要查看嗎？",
    puzzle_create_show_truth_confirm: "確認查看",
    puzzle_create_challenge: "挑戰試試",
    puzzle_create_try_self: "自己試試",
    puzzle_create_regenerate: "重新出題",
    puzzle_create_publish: "提交謎題",
    puzzle_create_ai_fill: "智能新建",
    puzzle_create_ai_fill_free: "本次免費",
    puzzle_create_ai_fill_failed: "AI生成失敗",
    puzzle_create_ai_mode_title: "智能創建",
    puzzle_create_ai_mode_fill: "自動補充",
    puzzle_create_ai_mode_fill_desc: "僅補充未填寫的內容",
    puzzle_create_ai_mode_optimize: "完全優化",
    puzzle_create_ai_mode_optimize_desc: "基於已有內容重新優化",
    puzzle_create_ai_extra_prompt: "額外提示（可選）",
    puzzle_create_ai_extra_prompt_placeholder: "例如：更恐怖一些、加入校園背景...",
    lantern_brewing: "正在調查謎題",
    lantern_drag_hint: "拖動光源 · 探索線索",
    lantern_waiting: "等待謎題準備中…",
    lantern_ready: "謎題準備完成",
    lantern_gen_failed: "生成失敗\n請稍後重試",
    lantern_back: "返回",
    puzzle_create_targets_label: "目標",
    puzzle_create_add_target: "添加目標",
    puzzle_create_origin_label: "來源",
    puzzle_create_origin_original: "原創",
    puzzle_create_origin_repost: "轉載",
    puzzle_create_author_name: "原作者名",
    puzzle_create_author_name_placeholder: "請輸入原作者名稱",
    puzzle_create_creating: "提交中...",
    puzzle_create_edit_title: "編輯謎題",
    puzzle_create_save_changes: "儲存修改",
    puzzle_create_publish_success_title: "提交成功",
    puzzle_create_publish_success_message: "謎題提交成功，等待審核",
    puzzle_create_publish_success_try: "現在試試",
    puzzle_create_publish_success_back: "返回首頁",
    puzzle_create_publish_failed: "提交失敗，請重試",
    puzzle_create_difficulty: "難度等級",
    puzzle_create_tags: "標籤",
    puzzle_create_tags_hint: "可選，最多3個",
    puzzle_create_preview: "預覽",
    puzzle_create_collapse: "收起",
    puzzle_create_expand: "展開預覽",
    puzzle_create_ready: "所有必填項已完成，可以發佈了",
    puzzle_create_incomplete: "請完成所有必填項",
    // puzzles_list
    puzzle_list_title: "進行中謎題",
    puzzle_list_empty_title: "還沒有進行過解謎",
    puzzle_list_empty_description: "選擇一個謎題開始解謎！",
    puzzle_list_empty_button: "開始解謎",
    puzzle_list_active: "正在進行",
    puzzle_list_completed: "已完成",
    puzzle_list_delete_success: "刪除成功",
    puzzle_list_delete_failed: "刪除失敗",
    puzzle_delete_confirm_title: "確認刪除謎題",
    puzzle_delete_confirm_description: "此謎題會從你的列表及公開區域隱藏。Web 端暫不支援復原此操作。",
    puzzle_delete_confirm_action: "刪除謎題",
    puzzle_list_loading: "正在翻閱卷宗...",
    // recharge
    recharge_title: "充值中心",
    recharge_insufficient_balance: "餘額不足，請先充值",
    recharge_balance: "當前餘額",
    recharge_balance_label: "境謎點",
    recharge_select_amount: "選擇充值金額",
    recharge_selected: "已選擇",
    recharge_confirm: "確認充值",
    recharge_processing: "處理中...",
    recharge_confirm_amount: "確認充值",
    recharge_subscribed: "訂閱中",
    recharge_back: "返回",
    recharge_launching_payment: "正在處理支付...",
    recharge_verifying: "正在確認購買結果...",
    recharge_subscription_section: "目前訂閱",
    recharge_sp_unit: "境謎點",
    recharge_sub_name: "境謎偵探Lite",
    recharge_sub_desc: "每月600境謎點+簽到加成",
    recharge_sub_period: "月",
    recharge_sub_perk1: "每月600境謎點",
    recharge_sub_perk2: "每日簽到7境謎點",
    recharge_basic_name: "境謎偵探Basic",
    recharge_basic_desc: "免費基礎檔",
    recharge_basic_perk: "簽到 2SP/日",
    recharge_basic_price: "免費",
    profile_check_in_success_lite: "簽到獲得7境謎點（Lite權益生效）",
    recharge_desc_300: "嘗鮮體驗",
    recharge_desc_900: "輕度解謎",
    recharge_desc_1500: "推理達人",
    recharge_desc_3000: "偵探暢玩",
    // discover
    discover_title: "發現謎題",
    discover_pickup_title: "精選推薦",
    discover_new: "新建",
    discover_latest: "最新",
    discover_hot_today: "今日最熱",
    discover_hot_week: "本週最熱",
    discover_login_warning: "請先登錄~",
    discover_loading: "正在搜尋線索...",
    // profile
    profile_title: "個人中心",
    profile_not_logged_in: "未登錄",
    profile_not_logged_in_description: "登錄後可查看個人數據、保存謎題進度",
    profile_login_now: "立即登錄",
    profile_avatar_alt: "用戶頭像",
    profile_coins: "境謎點",
    coins_unit: "境謎點（SP）",
    profile_recharge: "充值",
    profile_check_in: "簽到",
    profile_check_in_success: "簽到獲得2境謎點",
    profile_check_in_already: "今日已簽到",
    profile_network_error: "網絡問題",
    profile_tab_created: "我創建的",
    profile_tab_liked: "我喜歡的",
    profile_empty_created_title: "還沒有創建的謎題",
    profile_empty_created_description: "創建你的第一個謎題，與大家分享吧",
    profile_create_puzzle: "創建謎題",
    profile_empty_liked_title: "還沒有喜歡的謎題",
    profile_empty_liked_description: "去發現界面探索更多有趣的謎題吧",
    profile_go_discover: "去發現",
    profile_edit_nickname_title: "修改暱稱",
    profile_edit_nickname_description: "請輸入新的暱稱（最多12個字符）",
    profile_edit_nickname_placeholder: "請輸入暱稱",
    profile_edit_nickname_max: "暱稱不能超過12個字符",
    profile_edit_nickname_saved: "暱稱已更新",
    profile_edit_nickname_failed: "更新暱稱失敗，已恢復原暱稱",
    profile_edit_nickname_cancel: "取消",
    profile_edit_nickname_save: "保存",
    profile_avatar_upload_error: "請選擇圖片文件",
    profile_avatar_size_error: "圖片大小不能超過 5MB",
    profile_avatar_updated: "頭像已更新",
    // puzzle-card
    puzzle_card_publish: "發布",
    puzzle_card_reviewing: "審核中",
    puzzle_card_rejected: "違規",
    puzzle_card_completed: "已完成",
    puzzle_card_publish_failed: "發布失敗，請重試",
    puzzle_card_publish_retry: "發布失敗，請重試",
    puzzle_card_submitted_review: "已提交審核",
    puzzle_card_original: "原創",
    puzzle_card_repost: "轉載",
    puzzle_card_anonymous: "匿名",
    puzzle_card_author_default: "謎探",
    puzzle_card_new_this_week: "本週新謎",
    puzzle_card_solved_count: "人解過",
    // settings
    settings_title: "設置",
    settings_language: "語言設置",
    settings_privacy_policy: "隱私政策",
    settings_terms_of_service: "用戶協議",
    settings_logout: "退出登錄",
    settings_logout_confirm_title: "確認退出登錄",
    settings_logout_confirm_description: "退出登錄後，您將無法訪問個人數據，需要重新登錄。",
    settings_logout_confirm_cancel: "取消",
    settings_logout_confirm_action: "確認退出",
    settings_logout_success: "已退出登錄",
    settings_discord_title: "加入 Discord 社群",
    settings_discord_desc: "隨時反饋交流，獲取最新消息",
    settings_discord_join: "加入",
    settings_logout_failed: "退出登錄失敗",
    settings_delete_account: "刪除帳號",
    settings_delete_account_confirm_title: "確認刪除帳號",
    settings_delete_account_confirm_description: "刪除帳號，關聯的所有內容（帳號資料、包括發布的謎題數據）均會被刪除。刪除操作將由客服人員人工審核和確認執行，預計在14個工作日內完成，執行時會郵件通知。再次過程中可以隨時通過重新登錄來取消帳號刪除。",
    settings_delete_account_confirm_cancel: "取消",
    settings_delete_account_confirm_action: "確認刪除",
    settings_delete_account_success: "刪除帳號申請已提交",
    settings_delete_account_failed: "提交刪除帳號申請失敗",
    settings_delete_account_network_error: "遇到網絡問題，請再次嘗試",
    settings_theme: "主題",
    settings_theme_light: "淺色",
    settings_theme_dark: "深色",
    settings_preferences: "設置與偏好",
    topbar_login_account: "登錄帳號",
    topbar_login_bonus: "即刻開啟自由推理",
    topbar_community_join: "加入社群",
    topbar_community_qq: "QQ群",
    topbar_community_pending: "群組連結待配置",
    settings_section_appearance: "外觀",
    settings_section_community: "社群",
    settings_section_account: "帳號",
    settings_redeem_code: "兌換碼",
    settings_redeem_code_desc: "輸入活動或社群兌換碼，領取 SP",
    settings_redeem_code_placeholder: "請輸入兌換碼",
    settings_redeem_code_action: "兌換",
    settings_redeem_code_redeeming: "兌換中...",
    settings_redeem_code_success: "兌換成功，獲得 {amount} SP",
    settings_redeem_code_invalid: "兌換碼無效或已過期",
    settings_redeem_code_already_redeemed: "你已兌換過此兌換碼",
    settings_redeem_code_network_error: "兌換失敗，請稍後重試",
    login_account_deletion_title: "帳號刪除申請",
    login_account_deletion_description: "當前帳號已經提交刪除帳號申請，點擊“繼續”以繼續登錄並撤銷帳號刪除請求。",
    login_account_deletion_continue: "繼續",
    login_account_deletion_cancel: "取消",
    login_account_deletion_revoke_success: "已撤銷帳號刪除申請",
    login_account_deletion_revoke_failed: "撤銷帳號刪除申請失敗",
    login_account_deletion_network_error: "遇到網絡問題，請重新登錄",
    // login tutorial
    tutorial_welcome: "歡迎來到境謎，AI賦能的情境謎題。",
    tutorial_ask_familiar: "在開始之前，想先請問您：\n您是否熟悉 海龜湯/情境解謎 遊戲？",
    tutorial_response_yes: "好的，讓我直接為您快速介紹如何使用本軟件。",
    tutorial_response_no: "好的，海龜湯/情境解謎遊戲，正是如剛才這樣，由一方根據'謎面'提問，另一方根據'真相'回答'是'、'不是'或'與此無關'，直到真相被揭曉的遊戲。",
    tutorial_intro_demo: "接下來，我會給你一個謎面，請你選擇你想問的問題，我將回答。由於是演示教學，我會直接為您提供選項；實際遊玩時，您可任意打字提問你想問的內容。",
    tutorial_congrats: "恭喜你已經基本了解了海龜湯如何遊玩！現在，登錄賬號，一起進行更多的情境解謎吧！讓我再次致敬：",
    tutorial_puzzle_demo: "一個盲人進入一家餐廳，他點了一份海龜湯。在品嘗一口後，他突然痛苦悲鳴，走出餐廳自盡了。請猜出背後的真相是什麼？",
    tutorial_option_1: "他是被下毒了嗎？",
    tutorial_option_2: "他是回憶起了什麼嗎？",
    tutorial_option_3: "他是否曾和同伴被困海上荒島幾乎餓死時，喝過同伴給的'海龜湯'？",
    tutorial_option_4: "他是想起養過的海龜了嗎？",
    tutorial_option_5: "他是不是意識到，那次喝到的'海龜湯'，其實是同伴割肉做成的，所以他才堅持到獲救，而同伴不幸去世。",
    tutorial_got_it: "好的",
    tutorial_answer_yes: "是的",
    tutorial_answer_no: "不是",
    // navigation
    // themes
    theme_label: "主題",
    theme_all: "全部",
    theme_honkaku: "本格",
    theme_henkaku: "變格",
    theme_suspense: "懸疑",
    theme_casual: "輕鬆",
    theme_hardcore: "硬核",
    theme_horror: "微恐",
    theme_heartwarming: "溫情",
    // discover sort
    discover_sort_latest: "最新",
    discover_sort_hot_today: "今日最熱",
    discover_sort_hot_week: "本週最熱",
    // discover filter & sort (web)
    discover_filter_all: "全部",
    discover_filter_hot: "最熱",
    discover_filter_latest: "最新",
    discover_difficulty_easy: "簡單",
    discover_difficulty_medium: "中等",
    discover_difficulty_hard: "困難",
    discover_sortby_composite: "綜合排序",
    discover_sortby_newest: "最新發布",
    discover_sortby_most_liked: "最多點讚",
    discover_sortby_most_played: "最多挑戰",
    discover_no_result: "沒有找到符合條件的謎題",
    discover_puzzle_count: "道謎題",
    nav_puzzles: "謎題",
    nav_discover: "發現",
    nav_profile: "我的",
    nav_create: "新謎題",
    nav_recharge: "儲值中心",
    nav_settings: "設定",
    nav_my_puzzles: "進行中謎題",
    sidebar_investigation: "謎題",
    sidebar_case_files: "調查",
    sidebar_account: "帳戶",
    sidebar_tagline: "情境謎題推理"
};

// 英文
export const enUSTextData: TextDataType = {
    theme_quirky: "Quirky",
    puzzle_quirky_hint: "Quirky puzzles may require a little imagination~ Enjoy the deduction!",
    login_title: "Welcome to Scenigma.",
    login_subtitle: "Enter your email and password to log in. If the account doesn't exist, a new account will be created.",
    login_email_title: "Email",
    login_email_continue: "Continue",
    login_email_miss_toast: "Please enter your email",
    login_otp_miss_toast: "Please enter the verification code",
    login_email_wrong_toast: "Please check the email format",
    login_otp_send_toast: "Verification code has been sent to your email",
    login_loading: "Logging in...",
    login_fail_toast: "Login failed, please try again",
    login_network_error: "Network error. Please check your connection and try again.",
    login_otp_title: "Verification Code",
    login_otp_continue: "Login",
    login_get_otp_button: "Get Code",
    login_otp_cd: "seconds",
    login_quick_use: "Quick Play",
    login_guest: "Browse First",
    login_divider: "or",
    login_email_placeholder: "m@example.com",
    login_as_apple: "Continue with Apple",
    login_as_google: "Continue with Google",
    login_tips: "An account will be automatically registered on first login.\nBy continuing to use, you agree to our Terms of Service and Privacy Policy.",
    login_sign_in: "Sign In",
    login_sign_up: "Sign Up (Get 50 coins immediately!)",
    login_welcome_back: "Welcome back, ",
    login_hero_tagline: "Every mystery has a truth waiting in the shadows",
    login_hero_desc: "AI-powered mystery solving.\nAsk questions. Uncover the truth.",
    login_brand: "Scenigma",
    login_access_terminal: "Access Terminal",
    app_play: "Play",
    app_share: "Share",
    // puzzle_chat
    puzzle_soup_label: "Puzzle",
    puzzle_publish: "Publish",
    puzzle_reviewing: "Under Review",
    puzzle_like: "Like",
    puzzle_input_placeholder: "Enter your question or guess...",
    puzzle_report_title: "Report Puzzle",
    puzzle_report_description: "Please select a reason and provide detailed information",
    puzzle_report_reason_label: "Report Reason",
    puzzle_report_extra_label: "Additional Notes (Optional)",
    puzzle_report_extra_placeholder: "Please describe the reason in detail...",
    puzzle_report_cancel: "Cancel",
    puzzle_report_submit: "Confirm",
    puzzle_report_submitting: "Submitting...",
    puzzle_report_confirm: "Confirm",
    puzzle_report_success: "Report submitted successfully! We will process it as soon as possible.",
    puzzle_publish_failed: "Publish failed, please try again",
    puzzle_publish_retry: "Publish failed, please try again",
    puzzle_submitted_review: "Submitted for review",
    puzzle_like_failed: "Like failed, please try again",
    puzzle_unlike_failed: "Unlike failed, please try again",
    puzzle_report_reason_porn: "Pornography",
    puzzle_report_reason_violence: "Excessive Violence",
    puzzle_report_reason_politics: "Political Content",
    puzzle_report_reason_illegal: "Illegal Content",
    puzzle_report_reason_infringement: "Copyright Infringement",
    puzzle_report_reason_other: "Other",
    puzzle_clues_empty_hint: "Ask questions to get clues.",
    puzzle_clues_no_eliminated: "No eliminated clues yet",
    casefile_title: "Case File",
    casefile_subtitle: "Case File",
    casefile_complete: "Complete",
    casefile_in_progress: "In Progress",
    casefile_investigation: "Investigation",
    casefile_goals: "Goals",
    casefile_goals_count: "{achieved} of {total}",
    casefile_confirmed_yes: "Confirmed (YES)",
    casefile_eliminated_no: "Eliminated (NO)",
    puzzle_solve_hint: "Solve the following to complete the puzzle",
    puzzle_keypoint_murderer: "Murderer",
    puzzle_keypoint_method: "Method",
    puzzle_keypoint_motive: "Motive",
    puzzle_goals_hint: "Complete all key goals to reveal the answer",
    puzzle_truth_revealed_title: "Truth Revealed!",
    puzzle_truth_revealed_subtitle: "You have successfully solved all the mysteries!",
    puzzle_truth_view_full: "View Full Solution",
    puzzle_truth_answer_label: "Answer:",
    puzzle_truth_back_list: "Back to List",
    next_puzzle_title: "Next Case",
    next_puzzle_hook_label: "The Setup",
    next_puzzle_start: "Start Next",
    next_puzzle_start_countdown: "Start Next ({s})",
    next_puzzle_ai_generate: "Generate with AI",
    next_puzzle_loading: "Finding your next case…",
    next_puzzle_empty: "No new cases for now — let AI create one",
    giveup_title: "Stuck?",
    giveup_desc: "Before you go, try one of these",
    giveup_switch_puzzle: "Try another one",
    giveup_keep_playing: "Keep playing",
    giveup_switch_empty: "No better match found",
    giveup_switching: "Finding another one…",
    giveup_leave: "Leave",
    giveup_answer_title: "Would you like to see the answer?",
    giveup_answer_subtitle: "Sometimes your reasoning was not the problem",
    giveup_stat_solved: "Solved",
    giveup_stat_rounds: "Questions",
    giveup_reveal_free: "Reveal answer for free",
    giveup_free_daily_note: "First reveal today is free",
    giveup_reveal_prefix: "Reveal for",
    giveup_deducted_prefix: "Discounted",
    giveup_deducted_suffix: " SP",
    giveup_answer_label: "The Truth",
    giveup_answer_closure: "Here is what really happened",
    giveup_answer_done: "Got it",
    giveup_answer_failed: "Could not reveal the answer. Please try again",
    giveup_reward_label: "Saved",
    giveup_reveal_action: "Reveal answer",
    giveup_leave_mute: "Leave (don't ask again today)",
    // chat page
    chat_load_failed: "Failed to load conversation",
    chat_send_failed: "Send failed, please retry",
    chat_loading: "Loading case file...",
    chat_not_found: "Case not found",
    chat_ended: "Conversation ended",
    chat_enter_hint: "Press Enter to send, Shift + Enter for new line",
    chat_progress: "Progress",
    chat_stat_questions: "Questions",
    chat_stat_duration: "Duration",
    chat_stat_goals: "Goals",
    chat_stat_likes: "Likes",
    chat_answer_yes: "Yes",
    chat_answer_no: "No",
    chat_answer_both: "Yes & No",
    chat_answer_unrelated: "Irrelevant",
    chat_case_closed: "Case Closed",
    // puzzle_create
    puzzle_create_title: "Create Puzzle",
    puzzle_create_ai_tab: "AI Generate",
    puzzle_create_manual_tab: "Create Your Own",
    puzzle_create_ai_title: "Investigate a Mystery",
    puzzle_create_ai_description: "The AI co-detective will investigate an original puzzle for you. Pick a theme, light the lamp to investigate, and explore the story in the dark.",
    puzzle_create_ai_button: "Begin Investigation",
    puzzle_create_generating: "Generating...",
    puzzle_create_title_label: "Puzzle Title",
    puzzle_create_title_placeholder: "Give your puzzle a name",
    puzzle_create_soup_label: "Original Story",
    puzzle_create_soup_placeholder: "Describe the initial scenario (the simpler and more suspenseful, the better)",
    puzzle_create_truth_label: "Truth",
    puzzle_create_truth_placeholder: "The truth behind the puzzle (visible only to creators and users who solved it)",
    puzzle_create_truth_hidden: "Click \"Show Truth\" to view the answer",
    puzzle_create_show_truth: "Show Truth",
    puzzle_create_show_truth_dialog_title: "Confirm View Truth",
    puzzle_create_show_truth_dialog_description: "After viewing the truth, you will no longer be able to experience this puzzle as a challenger. Are you sure you want to view it?",
    puzzle_create_show_truth_confirm: "Confirm View",
    puzzle_create_challenge: "Try Challenge",
    puzzle_create_try_self: "Try It Myself",
    puzzle_create_regenerate: "Regenerate",
    puzzle_create_publish: "Submit Puzzle",
    puzzle_create_ai_fill: "Smart Create",
    puzzle_create_ai_fill_free: "Free this time",
    puzzle_create_ai_fill_failed: "AI generation failed",
    puzzle_create_ai_mode_title: "Smart Create",
    puzzle_create_ai_mode_fill: "Auto Fill",
    puzzle_create_ai_mode_fill_desc: "Only fill in blank fields",
    puzzle_create_ai_mode_optimize: "Full Optimize",
    puzzle_create_ai_mode_optimize_desc: "Optimize based on existing content",
    puzzle_create_ai_extra_prompt: "Extra prompt (optional)",
    puzzle_create_ai_extra_prompt_placeholder: "e.g., Make it scarier, add a campus setting...",
    lantern_brewing: "Brewing your mystery…",
    lantern_drag_hint: "Drag the light · Reveal clues",
    lantern_waiting: "Preparing your mystery…",
    lantern_ready: "Mystery ready",
    lantern_gen_failed: "Generation failed\nPlease try again later",
    lantern_back: "Back",
    puzzle_create_targets_label: "Targets",
    puzzle_create_add_target: "Add Target",
    puzzle_create_origin_label: "Origin",
    puzzle_create_origin_original: "Original",
    puzzle_create_origin_repost: "Repost",
    puzzle_create_author_name: "Original Author",
    puzzle_create_author_name_placeholder: "Enter original author name",
    puzzle_create_creating: "Submitting...",
    puzzle_create_edit_title: "Edit Puzzle",
    puzzle_create_save_changes: "Save Changes",
    puzzle_create_publish_success_title: "Submitted Successfully",
    puzzle_create_publish_success_message: "Puzzle submitted successfully, awaiting review",
    puzzle_create_publish_success_try: "Try Now",
    puzzle_create_publish_success_back: "Back to Home",
    puzzle_create_publish_failed: "Submit failed, please try again",
    puzzle_create_difficulty: "Difficulty",
    puzzle_create_tags: "Tags",
    puzzle_create_tags_hint: "Optional, max 3",
    puzzle_create_preview: "Preview",
    puzzle_create_collapse: "Collapse",
    puzzle_create_expand: "Expand Preview",
    puzzle_create_ready: "All required fields completed, ready to publish",
    puzzle_create_incomplete: "Please complete all required fields",
    // puzzles_list
    puzzle_list_title: "Puzzle List",
    puzzle_list_empty_title: "No puzzles solved yet",
    puzzle_list_empty_description: "Choose a puzzle to start solving!",
    puzzle_list_empty_button: "Start Solving",
    puzzle_list_active: "In Progress",
    puzzle_list_completed: "Completed",
    puzzle_list_delete_success: "Deleted successfully",
    puzzle_list_delete_failed: "Delete failed",
    puzzle_delete_confirm_title: "Delete this puzzle?",
    puzzle_delete_confirm_description: "This puzzle will be hidden from your list and public pages. It cannot currently be restored on the Web.",
    puzzle_delete_confirm_action: "Delete puzzle",
    puzzle_list_loading: "Reviewing case files...",
    // recharge
    recharge_title: "Recharge Center",
    recharge_insufficient_balance: "Insufficient balance, please recharge",
    recharge_balance: "Current Balance",
    recharge_balance_label: "Scenigma Points",
    recharge_select_amount: "Select Recharge Amount",
    recharge_selected: "Selected",
    recharge_confirm: "Confirm Recharge",
    recharge_processing: "Processing...",
    recharge_confirm_amount: "Confirm Recharge",
    recharge_subscribed: "Subscribed",
    recharge_back: "Back",
    recharge_launching_payment: "Processing payment...",
    recharge_verifying: "Verifying purchase...",
    recharge_subscription_section: "Current Subscription",
    recharge_sp_unit: "SP",
    recharge_sub_name: "Scenigma Detective Lite",
    recharge_sub_desc: "600 SP/month + check-in bonus",
    recharge_sub_period: "month",
    recharge_sub_perk1: "600 SP monthly",
    recharge_sub_perk2: "7 SP daily check-in",
    recharge_basic_name: "Scenigma Detective Basic",
    recharge_basic_desc: "Free basic tier",
    recharge_basic_perk: "Check-in 2SP/day",
    recharge_basic_price: "Free",
    profile_check_in_success_lite: "Check-in: +7 SP (Lite perk active)",
    recharge_desc_300: "Quick taste",
    recharge_desc_900: "Light puzzling",
    recharge_desc_1500: "Puzzle master",
    recharge_desc_3000: "Detective's delight",
    // discover
    discover_title: "Discover Puzzles",
    discover_pickup_title: "Pick Up",
    discover_new: "New",
    discover_latest: "Latest",
    discover_hot_today: "Hot Today",
    discover_hot_week: "Hot This Week",
    discover_login_warning: "Please login first~",
    discover_loading: "Searching for clues...",
    // profile
    profile_title: "Profile",
    profile_not_logged_in: "Not Logged In",
    profile_not_logged_in_description: "Log in to view personal data and save puzzle progress",
    profile_login_now: "Login Now",
    profile_avatar_alt: "User Avatar",
    profile_coins: "Scenigma Points",
    coins_unit: "SP",
    profile_recharge: "Recharge",
    profile_check_in: "Check In",
    profile_check_in_success: "Check-in: +2 SP",
    profile_check_in_already: "Already checked in today",
    profile_network_error: "Network error",
    profile_tab_created: "My Creations",
    profile_tab_liked: "My Likes",
    profile_empty_created_title: "No puzzles created yet",
    profile_empty_created_description: "Create your first puzzle and share it with everyone",
    profile_create_puzzle: "Create Puzzle",
    profile_empty_liked_title: "No liked puzzles yet",
    profile_empty_liked_description: "Go to Discover to explore more interesting puzzles",
    profile_go_discover: "Go Discover",
    profile_edit_nickname_title: "Edit Nickname",
    profile_edit_nickname_description: "Please enter a new nickname (max 12 characters)",
    profile_edit_nickname_placeholder: "Please enter nickname",
    profile_edit_nickname_max: "Nickname cannot exceed 12 characters",
    profile_edit_nickname_saved: "Nickname updated",
    profile_edit_nickname_failed: "Failed to update nickname, original nickname restored",
    profile_edit_nickname_cancel: "Cancel",
    profile_edit_nickname_save: "Save",
    profile_avatar_upload_error: "Please select an image file",
    profile_avatar_size_error: "Image size cannot exceed 5MB",
    profile_avatar_updated: "Avatar updated",
    // puzzle-card
    puzzle_card_publish: "Publish",
    puzzle_card_reviewing: "Under Review",
    puzzle_card_rejected: "Violation",
    puzzle_card_completed: "Completed",
    puzzle_card_publish_failed: "Publish failed, please try again",
    puzzle_card_publish_retry: "Publish failed, please try again",
    puzzle_card_submitted_review: "Submitted for review",
    puzzle_card_original: "Original",
    puzzle_card_repost: "Repost",
    puzzle_card_anonymous: "Anonymous",
    puzzle_card_author_default: "The Enigma",
    puzzle_card_new_this_week: "New this week",
    puzzle_card_solved_count: "solved",
    // settings
    settings_title: "Settings",
    settings_language: "Language Settings",
    settings_privacy_policy: "Privacy Policy",
    settings_terms_of_service: "Terms of Service",
    settings_logout: "Log Out",
    settings_logout_confirm_title: "Confirm Log Out",
    settings_logout_confirm_description: "After logging out, you will not be able to access personal data and will need to log in again.",
    settings_logout_confirm_cancel: "Cancel",
    settings_logout_confirm_action: "Confirm Log Out",
    settings_logout_success: "Logged out successfully",
    settings_discord_title: "Join our Discord",
    settings_discord_desc: "Share feedback and get the latest news",
    settings_discord_join: "Join",
    settings_logout_failed: "Log out failed",
    settings_delete_account: "Delete Account",
    settings_delete_account_confirm_title: "Confirm Account Deletion",
    settings_delete_account_confirm_description: "Deleting your account will permanently delete all associated content (account profile, including published puzzle data). The deletion will be reviewed and confirmed by customer service staff, expected to be completed within 14 business days. You will be notified by email when the deletion is executed. During this process, you can cancel the account deletion at any time by logging in again.",
    settings_delete_account_confirm_cancel: "Cancel",
    settings_delete_account_confirm_action: "Confirm Deletion",
    settings_delete_account_success: "Account deletion request submitted",
    settings_delete_account_failed: "Failed to submit account deletion request",
    settings_delete_account_network_error: "Network error, please try again",
    settings_theme: "Theme",
    settings_theme_light: "Light",
    settings_theme_dark: "Dark",
    settings_preferences: "Settings & Preferences",
    topbar_login_account: "Log in",
    topbar_login_bonus: "Start reasoning freely",
    topbar_community_join: "Join community",
    topbar_community_qq: "QQ Group",
    topbar_community_pending: "Group link not configured",
    settings_section_appearance: "Appearance",
    settings_section_community: "Community",
    settings_section_account: "Account",
    settings_redeem_code: "Redeem code",
    settings_redeem_code_desc: "Enter an event or community code to receive SP",
    settings_redeem_code_placeholder: "Enter code",
    settings_redeem_code_action: "Redeem",
    settings_redeem_code_redeeming: "Redeeming...",
    settings_redeem_code_success: "Redeemed successfully: {amount} SP",
    settings_redeem_code_invalid: "Invalid or expired code",
    settings_redeem_code_already_redeemed: "You have already redeemed this code",
    settings_redeem_code_network_error: "Redemption failed. Please try again",
    login_account_deletion_title: "Account Deletion Request",
    login_account_deletion_description: "Your account has a pending deletion request. Click 'Continue' to log in and cancel the account deletion request.",
    login_account_deletion_continue: "Continue",
    login_account_deletion_cancel: "Cancel",
    login_account_deletion_revoke_success: "Account deletion request cancelled",
    login_account_deletion_revoke_failed: "Failed to cancel account deletion request",
    login_account_deletion_network_error: "Network error, please log in again",
    // login tutorial
    tutorial_welcome: "Welcome to Situational Puzzles, AI-powered puzzle games.",
    tutorial_ask_familiar: "Before we begin, may I ask:\nAre you familiar with situational puzzle games?",
    tutorial_response_yes: "Good, let me quickly introduce how to use this app.",
    tutorial_response_no: "Good! Situational puzzle games work like this: one party asks questions based on the 'puzzle scenario', and the other party answers 'yes', 'no', or 'irrelevant' based on the 'truth', until the truth is revealed.",
    tutorial_intro_demo: "Next, I'll give you a puzzle scenario. Please choose the questions you want to ask, and I'll answer them. Since this is a demo tutorial, I'll provide options directly; in actual gameplay, you can type any questions you want to ask.",
    tutorial_congrats: "Congratulations! You've basically learned how to play situational puzzles! Now, log in to your account and let's do more situational puzzle solving together! Let me welcome you again:",
    tutorial_puzzle_demo: "A blind man enters a restaurant and orders turtle soup. After taking one sip, he suddenly cries out in pain, leaves the restaurant, and commits suicide. Can you guess what the truth behind this is?",
    tutorial_option_1: "Was he poisoned?",
    tutorial_option_2: "Did he remember something?",
    tutorial_option_3: "Was he once stranded on a deserted island with a companion, nearly starving to death, when he drank 'turtle soup' given by his companion?",
    tutorial_option_4: "Did he remember a turtle he once kept?",
    tutorial_option_5: "Did he realize that the 'turtle soup' he drank was actually made from his companion's flesh, which is why he survived until rescue, while his companion unfortunately died.",
    tutorial_got_it: "Got it",
    tutorial_answer_yes: "Yes",
    tutorial_answer_no: "No",
    // navigation
    // themes
    theme_label: "Theme",
    theme_all: "All",
    theme_honkaku: "Honkaku",
    theme_henkaku: "Henkaku",
    theme_suspense: "Suspense",
    theme_casual: "Casual",
    theme_hardcore: "Hardcore",
    theme_horror: "Horror",
    theme_heartwarming: "Heartwarming",
    // discover sort
    discover_sort_latest: "Latest",
    discover_sort_hot_today: "Hot Today",
    discover_sort_hot_week: "Hot This Week",
    // discover filter & sort (web)
    discover_filter_all: "All",
    discover_filter_hot: "Hot",
    discover_filter_latest: "Latest",
    discover_difficulty_easy: "Easy",
    discover_difficulty_medium: "Medium",
    discover_difficulty_hard: "Hard",
    discover_sortby_composite: "Composite",
    discover_sortby_newest: "Newest",
    discover_sortby_most_liked: "Most Liked",
    discover_sortby_most_played: "Most Played",
    discover_no_result: "No puzzles found matching your criteria",
    discover_puzzle_count: "puzzles",
    nav_puzzles: "Puzzles",
    nav_discover: "Discover",
    nav_profile: "Profile",
    nav_create: "Create Puzzle",
    nav_recharge: "Recharge",
    nav_settings: "Settings",
    nav_my_puzzles: "My Puzzles",
    sidebar_investigation: "Investigation",
    sidebar_case_files: "Case Files",
    sidebar_account: "Account",
    sidebar_tagline: "Lateral Thinking Puzzles"
};

// 日语
export const jaJPTextData: TextDataType = {
    theme_quirky: "おふざけ",
    puzzle_quirky_hint: "おふざけ系の謎は想像力が必要かも～思いきり推理を楽しんで！",
    login_title: "境謎へようこそ。",
    login_subtitle: "メールアドレスとパスワードを入力してログインしてください。アカウントが存在しない場合は、新しいアカウントが作成されます。",
    login_email_title: "メールアドレス",
    login_email_continue: "続ける",
    login_email_miss_toast: "メールアドレスを入力してください",
    login_otp_miss_toast: "確認コードを入力してください",
    login_email_wrong_toast: "メールアドレスの形式を確認してください",
    login_otp_send_toast: "確認コードがメールに送信されました",
    login_loading: "ログイン中...",
    login_fail_toast: "ログインに失敗しました。もう一度お試しください",
    login_network_error: "ネットワーク接続に失敗しました。接続を確認して再試行してください。",
    login_otp_title: "確認コード",
    login_otp_continue: "ログイン",
    login_get_otp_button: "コードを取得",
    login_otp_cd: "秒",
    login_quick_use: "クイックプレイ",
    login_guest: "まず見てみる",
    login_divider: "または",
    login_email_placeholder: "m@example.com",
    login_as_apple: "Appleで続ける",
    login_as_google: "Googleで続ける",
    login_tips: "初回ログイン時にアカウントが自動登録されます。\n続行することで、利用規約およびプライバシーポリシーに同意したものとみなされます。",
    login_sign_in: "ログイン",
    login_sign_up: "サインアップ（すぐに50コイン獲得！）",
    login_welcome_back: "おかえりなさい、",
    login_hero_tagline: "すべての謎の裏に、明かされるべき真実がある",
    login_hero_desc: "AIが駆動する推理謎解き。\n質問して、探索して、真実を解き明かそう。",
    login_brand: "境 謎",
    login_access_terminal: "アクセス端末",
    app_play: "プレイ",
    app_share: "共有",
    // puzzle_chat
    puzzle_soup_label: "謎",
    puzzle_publish: "公開",
    puzzle_reviewing: "審査中",
    puzzle_like: "いいね",
    puzzle_input_placeholder: "質問や推測を入力...",
    puzzle_report_title: "パズルを報告",
    puzzle_report_description: "報告理由を選択し、詳細情報を記入してください",
    puzzle_report_reason_label: "報告理由",
    puzzle_report_extra_label: "補足説明（任意）",
    puzzle_report_extra_placeholder: "報告理由を詳しく説明してください...",
    puzzle_report_cancel: "キャンセル",
    puzzle_report_submit: "確認",
    puzzle_report_submitting: "送信中...",
    puzzle_report_confirm: "確認",
    puzzle_report_success: "報告が正常に送信されました。できるだけ早く処理いたします。",
    puzzle_publish_failed: "公開に失敗しました。もう一度お試しください",
    puzzle_publish_retry: "公開に失敗しました。もう一度お試しください",
    puzzle_submitted_review: "審査に提出されました",
    puzzle_like_failed: "いいねに失敗しました。もう一度お試しください",
    puzzle_unlike_failed: "いいね解除に失敗しました。もう一度お試しください",
    puzzle_report_reason_porn: "ポルノ",
    puzzle_report_reason_violence: "過度な暴力表現",
    puzzle_report_reason_politics: "政治的内容",
    puzzle_report_reason_illegal: "違法な内容",
    puzzle_report_reason_infringement: "著作権侵害",
    puzzle_report_reason_other: "その他",
    puzzle_clues_empty_hint: "質問して手がかりを手に入れましょう。",
    puzzle_clues_no_eliminated: "排除された情報はまだありません",
    casefile_title: "事件ファイル",
    casefile_subtitle: "Case File",
    casefile_complete: "完了",
    casefile_in_progress: "調査中",
    casefile_investigation: "捜査の進展",
    casefile_goals: "目標",
    casefile_goals_count: "{achieved} / {total}",
    casefile_confirmed_yes: "確認済み (YES)",
    casefile_eliminated_no: "除外済み (NO)",
    puzzle_solve_hint: "以下の問題を解決して謎を完成させましょう",
    puzzle_keypoint_murderer: "犯人",
    puzzle_keypoint_method: "手口",
    puzzle_keypoint_motive: "動機",
    puzzle_goals_hint: "すべての重要な目標を達成すると、答えが明らかになります",
    puzzle_truth_revealed_title: "真相大白！",
    puzzle_truth_revealed_subtitle: "すべての謎を解きました！",
    puzzle_truth_view_full: "完全な答えを見る",
    puzzle_truth_answer_label: "答え:",
    puzzle_truth_back_list: "リストに戻る",
    next_puzzle_title: "次の謎",
    next_puzzle_hook_label: "問題をチラ見",
    next_puzzle_start: "次へ進む",
    next_puzzle_start_countdown: "次へ進む ({s})",
    next_puzzle_ai_generate: "AIに新作を作らせる",
    next_puzzle_loading: "次の謎を探しています…",
    next_puzzle_empty: "新しい謎がありません。AIに作らせましょう",
    giveup_title: "行き詰まった？",
    giveup_desc: "帰る前に、これを試してみて",
    giveup_switch_puzzle: "別の謎を試す",
    giveup_keep_playing: "続けて遊ぶ",
    giveup_switch_empty: "適した謎が見つかりません",
    giveup_switching: "別の謎を探しています…",
    giveup_leave: "退出",
    giveup_answer_title: "答えを見てみますか？",
    giveup_answer_subtitle: "推理が間違っていたとは限りません",
    giveup_stat_solved: "解けた目標",
    giveup_stat_rounds: "質問数",
    giveup_reveal_free: "無料で答えを見る",
    giveup_free_daily_note: "今日は初回無料",
    giveup_reveal_prefix: "答えを見るには",
    giveup_deducted_prefix: "割引後",
    giveup_deducted_suffix: " SP",
    giveup_answer_label: "真相",
    giveup_answer_closure: "事件の真相はこうでした",
    giveup_answer_done: "わかりました",
    giveup_answer_failed: "答えを表示できませんでした。もう一度お試しください",
    giveup_reward_label: "節約額",
    giveup_reveal_action: "答えを見る",
    giveup_leave_mute: "退出（今日は再表示しない）",
    // chat page
    chat_load_failed: "会話の読み込みに失敗しました",
    chat_send_failed: "送信に失敗しました。もう一度お試しください",
    chat_loading: "事件ファイルを読み込み中...",
    chat_not_found: "事件が見つかりません",
    chat_ended: "会話が終了しました",
    chat_enter_hint: "Enter で送信、Shift + Enter で改行",
    chat_progress: "進捗",
    chat_stat_questions: "質問",
    chat_stat_duration: "所要時間",
    chat_stat_goals: "目標",
    chat_stat_likes: "いいね",
    chat_answer_yes: "はい",
    chat_answer_no: "いいえ",
    chat_answer_both: "どちらとも",
    chat_answer_unrelated: "無関係",
    chat_case_closed: "事件解決",
    // puzzle_create
    puzzle_create_title: "パズルを作成",
    puzzle_create_ai_tab: "AI生成",
    puzzle_create_manual_tab: "自分で作成",
    puzzle_create_ai_title: "謎を捜査する",
    puzzle_create_ai_description: "AI協力探偵があなたのためにオリジナルのパズルを捜査します。テーマを選び、ランプを灯して捜査し、暗闇の物語を探索しましょう。",
    puzzle_create_ai_button: "捜査開始",
    puzzle_create_generating: "生成中...",
    puzzle_create_title_label: "パズルのタイトル",
    puzzle_create_title_placeholder: "パズルに名前を付けてください",
    puzzle_create_soup_label: "元のストーリー",
    puzzle_create_soup_placeholder: "パズルの初期シナリオを説明してください（シンプルでサスペンスに富むほど良い）",
    puzzle_create_truth_label: "真実",
    puzzle_create_truth_placeholder: "パズルの真実（作成者と解決済みユーザーのみが閲覧可能）",
    puzzle_create_truth_hidden: "「真実を表示」をクリックして答えを確認",
    puzzle_create_show_truth: "真実を表示",
    puzzle_create_show_truth_dialog_title: "真実を確認",
    puzzle_create_show_truth_dialog_description: "真実を確認すると、このパズルを挑戦者として体験できなくなります。確認してもよろしいですか？",
    puzzle_create_show_truth_confirm: "確認する",
    puzzle_create_challenge: "挑戦してみる",
    puzzle_create_try_self: "自分で試す",
    puzzle_create_regenerate: "再生成",
    puzzle_create_publish: "パズルを提出",
    puzzle_create_ai_fill: "スマート作成",
    puzzle_create_ai_fill_free: "今回無料",
    puzzle_create_ai_fill_failed: "AI生成に失敗しました",
    puzzle_create_ai_mode_title: "スマート作成",
    puzzle_create_ai_mode_fill: "自動補完",
    puzzle_create_ai_mode_fill_desc: "未入力の項目のみ補完",
    puzzle_create_ai_mode_optimize: "完全最適化",
    puzzle_create_ai_mode_optimize_desc: "既存の内容に基づいて最適化",
    puzzle_create_ai_extra_prompt: "追加プロンプト（任意）",
    puzzle_create_ai_extra_prompt_placeholder: "例：もっと怖く、学校を舞台に...",
    lantern_brewing: "謎を醸成中…",
    lantern_drag_hint: "光源をドラッグ · 手がかりを探る",
    lantern_waiting: "謎の準備中…",
    lantern_ready: "謎の準備完了",
    lantern_gen_failed: "生成失敗\nしばらくしてからお試しください",
    lantern_back: "戻る",
    puzzle_create_targets_label: "目標",
    puzzle_create_add_target: "目標を追加",
    puzzle_create_origin_label: "出典",
    puzzle_create_origin_original: "オリジナル",
    puzzle_create_origin_repost: "転載",
    puzzle_create_author_name: "原作者名",
    puzzle_create_author_name_placeholder: "原作者名を入力",
    puzzle_create_creating: "提出中...",
    puzzle_create_edit_title: "パズルを編集",
    puzzle_create_save_changes: "変更を保存",
    puzzle_create_publish_success_title: "提出完了",
    puzzle_create_publish_success_message: "パズルの提出が完了しました。審査をお待ちください",
    puzzle_create_publish_success_try: "今すぐ試す",
    puzzle_create_publish_success_back: "ホームに戻る",
    puzzle_create_publish_failed: "提出に失敗しました。もう一度お試しください",
    puzzle_create_difficulty: "難易度",
    puzzle_create_tags: "タグ",
    puzzle_create_tags_hint: "任意、最大3つ",
    puzzle_create_preview: "プレビュー",
    puzzle_create_collapse: "折りたたむ",
    puzzle_create_expand: "プレビューを展開",
    puzzle_create_ready: "すべての必須項目が完了しました。公開できます",
    puzzle_create_incomplete: "すべての必須項目を入力してください",
    // puzzles_list
    puzzle_list_title: "パズル一覧",
    puzzle_list_empty_title: "まだパズルを解いていません",
    puzzle_list_empty_description: "パズルを選択して解き始めましょう！",
    puzzle_list_empty_button: "解き始める",
    puzzle_list_active: "進行中",
    puzzle_list_completed: "完了",
    puzzle_list_delete_success: "削除に成功しました",
    puzzle_list_delete_failed: "削除に失敗しました",
    puzzle_delete_confirm_title: "このパズルを削除しますか？",
    puzzle_delete_confirm_description: "このパズルはリストと公開ページから非表示になります。現在 Web では元に戻せません。",
    puzzle_delete_confirm_action: "パズルを削除",
    puzzle_list_loading: "調書を確認中...",
    // recharge
    recharge_title: "チャージセンター",
    recharge_insufficient_balance: "残高不足です。チャージしてください",
    recharge_balance: "現在の残高",
    recharge_balance_label: "境謎ポイント",
    recharge_select_amount: "チャージ金額を選択",
    recharge_selected: "選択済み",
    recharge_confirm: "チャージを確認",
    recharge_processing: "処理中...",
    recharge_confirm_amount: "チャージを確認",
    recharge_subscribed: "購読中",
    recharge_back: "戻る",
    recharge_launching_payment: "お支払い処理中...",
    recharge_verifying: "購入結果を確認中...",
    recharge_subscription_section: "現在のサブスクリプション",
    recharge_sp_unit: "SP",
    recharge_sub_name: "境謎探偵Lite",
    recharge_sub_desc: "毎月600SP+チェックインボーナス",
    recharge_sub_period: "月",
    recharge_sub_perk1: "毎月600SP",
    recharge_sub_perk2: "毎日チェックイン7SP",
    recharge_basic_name: "境謎探偵Basic",
    recharge_basic_desc: "無料ベーシック",
    recharge_basic_perk: "チェックイン 2SP/日",
    recharge_basic_price: "無料",
    profile_check_in_success_lite: "チェックイン: +7SP（Lite特典適用）",
    recharge_desc_300: "お試し体験",
    recharge_desc_900: "ライト解謎",
    recharge_desc_1500: "推理マスター",
    recharge_desc_3000: "探偵満喫",
    // discover
    discover_title: "パズルを発見",
    discover_pickup_title: "ピックアップ",
    discover_new: "新規作成",
    discover_latest: "最新",
    discover_hot_today: "今日の人気",
    discover_hot_week: "今週の人気",
    discover_login_warning: "まずログインしてください~",
    discover_loading: "手がかりを探しています...",
    // profile
    profile_title: "プロフィール",
    profile_not_logged_in: "ログインしていません",
    profile_not_logged_in_description: "ログインすると、個人データを閲覧し、パズルの進捗を保存できます",
    profile_login_now: "今すぐログイン",
    profile_avatar_alt: "ユーザーアバター",
    profile_coins: "境謎ポイント",
    coins_unit: "境謎ポイント（SP）",
    profile_recharge: "チャージ",
    profile_check_in: "チェックイン",
    profile_check_in_success: "チェックイン: +2SP",
    profile_check_in_already: "本日は既にチェックイン済みです",
    profile_network_error: "ネットワークエラー",
    profile_tab_created: "作成したもの",
    profile_tab_liked: "いいねしたもの",
    profile_empty_created_title: "まだパズルを作成していません",
    profile_empty_created_description: "最初のパズルを作成して、みんなと共有しましょう",
    profile_create_puzzle: "パズルを作成",
    profile_empty_liked_title: "まだいいねしたパズルがありません",
    profile_empty_liked_description: "発見ページでより多くの面白いパズルを探索しましょう",
    profile_go_discover: "発見へ",
    profile_edit_nickname_title: "ニックネームを編集",
    profile_edit_nickname_description: "新しいニックネームを入力してください（最大12文字）",
    profile_edit_nickname_placeholder: "ニックネームを入力してください",
    profile_edit_nickname_max: "ニックネームは12文字を超えることはできません",
    profile_edit_nickname_saved: "ニックネームが更新されました",
    profile_edit_nickname_failed: "ニックネームの更新に失敗しました。元のニックネームに戻しました",
    profile_edit_nickname_cancel: "キャンセル",
    profile_edit_nickname_save: "保存",
    profile_avatar_upload_error: "画像ファイルを選択してください",
    profile_avatar_size_error: "画像サイズは5MBを超えることはできません",
    profile_avatar_updated: "アバターが更新されました",
    // puzzle-card
    puzzle_card_publish: "公開",
    puzzle_card_reviewing: "審査中",
    puzzle_card_rejected: "違反",
    puzzle_card_completed: "完了",
    puzzle_card_publish_failed: "公開に失敗しました。もう一度お試しください",
    puzzle_card_publish_retry: "公開に失敗しました。もう一度お試しください",
    puzzle_card_submitted_review: "審査に提出されました",
    puzzle_card_original: "オリジナル",
    puzzle_card_repost: "転載",
    puzzle_card_anonymous: "匿名",
    puzzle_card_author_default: "謎探",
    puzzle_card_new_this_week: "今週の新着",
    puzzle_card_solved_count: "人が解いた",
    // settings
    settings_title: "設定",
    settings_language: "言語設定",
    settings_privacy_policy: "プライバシーポリシー",
    settings_terms_of_service: "利用規約",
    settings_logout: "ログアウト",
    settings_logout_confirm_title: "ログアウトを確認",
    settings_logout_confirm_description: "ログアウト後、個人データにアクセスできなくなり、再度ログインする必要があります。",
    settings_logout_confirm_cancel: "キャンセル",
    settings_logout_confirm_action: "ログアウトを確認",
    settings_logout_success: "正常にログアウトしました",
    settings_discord_title: "Discord コミュニティに参加",
    settings_discord_desc: "フィードバックや最新情報をいつでも",
    settings_discord_join: "参加",
    settings_logout_failed: "ログアウトに失敗しました",
    settings_delete_account: "アカウント削除",
    settings_delete_account_confirm_title: "アカウント削除の確認",
    settings_delete_account_confirm_description: "アカウントを削除すると、関連するすべてのコンテンツ（アカウントプロフィール、公開されたパズルデータを含む）が削除されます。削除操作はカスタマーサービス担当者が手動で審査・確認し、14営業日以内に完了する予定です。実行時にはメールで通知されます。このプロセス中は、いつでも再度ログインすることでアカウント削除をキャンセルできます。",
    settings_delete_account_confirm_cancel: "キャンセル",
    settings_delete_account_confirm_action: "削除を確認",
    settings_delete_account_success: "アカウント削除リクエストが送信されました",
    settings_delete_account_failed: "アカウント削除リクエストの送信に失敗しました",
    settings_delete_account_network_error: "ネットワークエラーが発生しました。もう一度お試しください",
    settings_theme: "テーマ",
    settings_theme_light: "ライト",
    settings_theme_dark: "ダーク",
    settings_preferences: "設定と環境",
    topbar_login_account: "ログイン",
    topbar_login_bonus: "自由な推理を今すぐ始める",
    topbar_community_join: "コミュニティに参加",
    topbar_community_qq: "QQグループ",
    topbar_community_pending: "グループリンク未設定",
    settings_section_appearance: "外観",
    settings_section_community: "コミュニティ",
    settings_section_account: "アカウント",
    settings_redeem_code: "交換コード",
    settings_redeem_code_desc: "イベントやコミュニティのコードで SP を受け取る",
    settings_redeem_code_placeholder: "コードを入力",
    settings_redeem_code_action: "交換",
    settings_redeem_code_redeeming: "交換中...",
    settings_redeem_code_success: "交換成功: {amount} SP",
    settings_redeem_code_invalid: "無効または期限切れのコードです",
    settings_redeem_code_already_redeemed: "このコードはすでに交換済みです",
    settings_redeem_code_network_error: "交換に失敗しました。もう一度お試しください",
    login_account_deletion_title: "アカウント削除リクエスト",
    login_account_deletion_description: "現在のアカウントは削除リクエストが提出されています。「続ける」をクリックしてログインし、アカウント削除リクエストを取り消してください。",
    login_account_deletion_continue: "続ける",
    login_account_deletion_cancel: "キャンセル",
    login_account_deletion_revoke_success: "アカウント削除リクエストがキャンセルされました",
    login_account_deletion_revoke_failed: "アカウント削除リクエストのキャンセルに失敗しました",
    login_account_deletion_network_error: "ネットワークエラーが発生しました。再度ログインしてください",
    // login tutorial
    tutorial_welcome: "シチュエーションパズルへようこそ。AIを活用したパズルゲームです。",
    tutorial_ask_familiar: "始める前に、お聞きします：\nシチュエーションパズルゲームに慣れていますか？",
    tutorial_response_yes: "わかりました。このアプリの使い方を簡単にご紹介します。",
    tutorial_response_no: "わかりました！シチュエーションパズルゲームは、一方が「パズルのシナリオ」に基づいて質問し、もう一方が「真実」に基づいて「はい」「いいえ」「関係ない」と答えるゲームで、真実が明らかになるまで続けます。",
    tutorial_intro_demo: "次に、パズルのシナリオを提示します。質問したい内容を選択してください。私が答えます。これはデモチュートリアルなので、直接オプションを提供します。実際のゲームプレイでは、質問したい内容を自由に入力できます。",
    tutorial_congrats: "おめでとうございます！シチュエーションパズルの遊び方を基本的に理解しました！では、アカウントにログインして、一緒にもっと多くのシチュエーションパズルを解きましょう！改めてようこそ：",
    tutorial_puzzle_demo: "目の見えない男性がレストランに入り、カメのスープを注文しました。一口飲んだ後、突然苦痛の叫び声を上げ、レストランを出て自殺しました。この背後にある真実を推測できますか？",
    tutorial_option_1: "彼は毒を盛られましたか？",
    tutorial_option_2: "彼は何かを思い出しましたか？",
    tutorial_option_3: "彼はかつて仲間と無人島に閉じ込められ、餓死寸前の時に、仲間からもらった「カメのスープ」を飲んだことがありますか？",
    tutorial_option_4: "彼はかつて飼っていたカメを思い出しましたか？",
    tutorial_option_5: "彼は、その時に飲んだ「カメのスープ」が実際には仲間の肉で作られたものであり、それが彼が救助されるまで生き延びた理由であり、仲間は不幸にも亡くなったことに気づいたのではないでしょうか。",
    tutorial_got_it: "わかりました",
    tutorial_answer_yes: "はい",
    tutorial_answer_no: "いいえ",
    // navigation
    // themes
    theme_label: "テーマ",
    theme_all: "すべて",
    theme_honkaku: "本格",
    theme_henkaku: "変格",
    theme_suspense: "サスペンス",
    theme_casual: "カジュアル",
    theme_hardcore: "ハードコア",
    theme_horror: "ホラー",
    theme_heartwarming: "ハートウォーミング",
    // discover sort
    discover_sort_latest: "最新",
    discover_sort_hot_today: "今日の人気",
    discover_sort_hot_week: "今週の人気",
    // discover filter & sort (web)
    discover_filter_all: "すべて",
    discover_filter_hot: "人気",
    discover_filter_latest: "最新",
    discover_difficulty_easy: "簡単",
    discover_difficulty_medium: "普通",
    discover_difficulty_hard: "難しい",
    discover_sortby_composite: "総合順",
    discover_sortby_newest: "最新順",
    discover_sortby_most_liked: "いいね順",
    discover_sortby_most_played: "プレイ順",
    discover_no_result: "条件に合うパズルが見つかりません",
    discover_puzzle_count: "件のパズル",
    nav_puzzles: "パズル",
    nav_discover: "発見",
    nav_profile: "プロフィール",
    nav_create: "パズル作成",
    nav_recharge: "チャージ",
    nav_settings: "設定",
    nav_my_puzzles: "マイパズル",
    sidebar_investigation: "捜査",
    sidebar_case_files: "事件ファイル",
    sidebar_account: "アカウント",
    sidebar_tagline: "水平思考パズル"
};

// 西班牙语
export const esESTextData: TextDataType = {
    theme_quirky: "Disparatado",
    puzzle_quirky_hint: "Los acertijos disparatados pueden requerir imaginación. ¡Disfruta deduciendo!",
    login_title: "Bienvenido a Scenigma.",
    login_subtitle: "Ingresa tu correo electrónico y contraseña para iniciar sesión. Si la cuenta no existe, se creará una nueva cuenta automáticamente.",
    login_email_title: "Correo electrónico",
    login_email_continue: "Continuar",
    login_email_miss_toast: "Por favor ingresa tu correo electrónico",
    login_otp_miss_toast: "Por favor ingresa el código de verificación",
    login_email_wrong_toast: "Por favor verifica el formato del correo electrónico",
    login_otp_send_toast: "El código de verificación ha sido enviado a tu correo electrónico",
    login_loading: "Iniciando sesión...",
    login_fail_toast: "Error al iniciar sesión, por favor inténtalo de nuevo",
    login_network_error: "Error de red. Verifica tu conexión e inténtalo de nuevo.",
    login_otp_title: "Código de verificación",
    login_otp_continue: "Iniciar sesión",
    login_get_otp_button: "Obtener código",
    login_otp_cd: "segundos",
    login_quick_use: "Juego rápido",
    login_guest: "Solo explorar",
    login_divider: "o",
    login_email_placeholder: "m@example.com",
    login_as_apple: "Continuar con Apple",
    login_as_google: "Continuar con Google",
    login_tips: "Se registrará automáticamente una cuenta en el primer inicio de sesión.\nAl continuar usando, acepta nuestros Términos de Servicio y Política de Privacidad.",
    login_sign_in: "Iniciar sesión",
    login_sign_up: "Registrarse (¡Obtén 50 monedas inmediatamente!)",
    login_welcome_back: "Bienvenido de nuevo, ",
    login_hero_tagline: "Cada misterio tiene una verdad esperando en las sombras",
    login_hero_desc: "Resolución de misterios con IA.\nHaz preguntas. Descubre la verdad.",
    login_brand: "Scenigma",
    login_access_terminal: "Terminal de acceso",
    app_play: "Jugar",
    app_share: "Compartir",
    // puzzle_chat
    puzzle_soup_label: "Puzzle",
    puzzle_publish: "Publicar",
    puzzle_reviewing: "En revisión",
    puzzle_like: "Me gusta",
    puzzle_input_placeholder: "Ingresa tu pregunta o conjetura...",
    puzzle_report_title: "Reportar puzzle",
    puzzle_report_description: "Por favor selecciona un motivo y proporciona información detallada",
    puzzle_report_reason_label: "Motivo del reporte",
    puzzle_report_extra_label: "Notas adicionales (opcional)",
    puzzle_report_extra_placeholder: "Por favor describe el motivo en detalle...",
    puzzle_report_cancel: "Cancelar",
    puzzle_report_submit: "Confirmar",
    puzzle_report_submitting: "Enviando...",
    puzzle_report_confirm: "Confirmar",
    puzzle_report_success: "¡Reporte enviado exitosamente! Lo procesaremos lo antes posible.",
    puzzle_publish_failed: "Error al publicar, por favor intenta de nuevo",
    puzzle_publish_retry: "Error al publicar, por favor intenta de nuevo",
    puzzle_submitted_review: "Enviado para revisión",
    puzzle_like_failed: "Error al dar me gusta, por favor intenta de nuevo",
    puzzle_unlike_failed: "Error al quitar me gusta, por favor intenta de nuevo",
    puzzle_report_reason_porn: "Pornografía",
    puzzle_report_reason_violence: "Violencia excesiva",
    puzzle_report_reason_politics: "Contenido político",
    puzzle_report_reason_illegal: "Contenido ilegal",
    puzzle_report_reason_infringement: "Violación de derechos de autor",
    puzzle_report_reason_other: "Otro",
    puzzle_clues_empty_hint: "Haz preguntas para obtener pistas.",
    puzzle_clues_no_eliminated: "Aún no hay pistas eliminadas",
    casefile_title: "Expediente",
    casefile_subtitle: "Case File",
    casefile_complete: "Completo",
    casefile_in_progress: "En progreso",
    casefile_investigation: "Investigación",
    casefile_goals: "Objetivos",
    casefile_goals_count: "{achieved} de {total}",
    casefile_confirmed_yes: "Confirmado (SÍ)",
    casefile_eliminated_no: "Eliminado (NO)",
    puzzle_solve_hint: "Resuelve lo siguiente para completar el acertijo",
    puzzle_keypoint_murderer: "Asesino",
    puzzle_keypoint_method: "Método",
    puzzle_keypoint_motive: "Motivo",
    puzzle_goals_hint: "Completa todos los objetivos clave para revelar la respuesta",
    puzzle_truth_revealed_title: "¡Verdad revelada!",
    puzzle_truth_revealed_subtitle: "¡Has resuelto todos los misterios!",
    puzzle_truth_view_full: "Ver solución completa",
    puzzle_truth_answer_label: "Respuesta:",
    puzzle_truth_back_list: "Volver a la lista",
    next_puzzle_title: "Próximo caso",
    next_puzzle_hook_label: "Vistazo al enigma",
    next_puzzle_start: "Empezar el siguiente",
    next_puzzle_start_countdown: "Empezar el siguiente ({s})",
    next_puzzle_ai_generate: "Generar con IA",
    next_puzzle_loading: "Buscando tu próximo caso…",
    next_puzzle_empty: "No hay casos nuevos por ahora, deja que la IA cree uno",
    giveup_title: "¿Atascado?",
    giveup_desc: "Antes de irte, prueba una de estas",
    giveup_switch_puzzle: "Probar otro",
    giveup_keep_playing: "Seguir jugando",
    giveup_switch_empty: "No se encontró una mejor opción",
    giveup_switching: "Buscando otro para ti…",
    giveup_leave: "Salir",
    giveup_answer_title: "¿Quieres ver la respuesta?",
    giveup_answer_subtitle: "A veces el problema no era tu razonamiento",
    giveup_stat_solved: "Resueltos",
    giveup_stat_rounds: "Preguntas",
    giveup_reveal_free: "Ver la respuesta gratis",
    giveup_free_daily_note: "La primera de hoy es gratis",
    giveup_reveal_prefix: "Ver por",
    giveup_deducted_prefix: "Descuento",
    giveup_deducted_suffix: " SP",
    giveup_answer_label: "La verdad",
    giveup_answer_closure: "Esto es lo que ocurrió",
    giveup_answer_done: "Entendido",
    giveup_answer_failed: "No se pudo mostrar la respuesta. Inténtalo de nuevo",
    giveup_reward_label: "Ahorrado",
    giveup_reveal_action: "Ver respuesta",
    giveup_leave_mute: "Salir (no preguntar de nuevo hoy)",
    // chat page
    chat_load_failed: "Error al cargar la conversación",
    chat_send_failed: "Error al enviar, inténtalo de nuevo",
    chat_loading: "Cargando expediente...",
    chat_not_found: "Caso no encontrado",
    chat_ended: "Conversación finalizada",
    chat_enter_hint: "Pulsa Enter para enviar, Shift + Enter para nueva línea",
    chat_progress: "Progreso",
    chat_stat_questions: "Preguntas",
    chat_stat_duration: "Duración",
    chat_stat_goals: "Objetivos",
    chat_stat_likes: "Me gusta",
    chat_answer_yes: "Sí",
    chat_answer_no: "No",
    chat_answer_both: "Sí y No",
    chat_answer_unrelated: "Irrelevante",
    chat_case_closed: "Caso Cerrado",
    // puzzle_create
    puzzle_create_title: "Crear puzzle",
    puzzle_create_ai_tab: "Generar con IA",
    puzzle_create_manual_tab: "Crear el mío",
    puzzle_create_ai_title: "Investiga un misterio",
    puzzle_create_ai_description: "El detective asistente de IA investigará un puzzle original para ti. Elige un tema, enciende la lámpara para investigar y explora la historia en la oscuridad.",
    puzzle_create_ai_button: "Iniciar investigación",
    puzzle_create_generating: "Generando...",
    puzzle_create_title_label: "Título del puzzle",
    puzzle_create_title_placeholder: "Dale un nombre a tu puzzle",
    puzzle_create_soup_label: "Historia original",
    puzzle_create_soup_placeholder: "Describe el escenario inicial (cuanto más simple y lleno de suspenso, mejor)",
    puzzle_create_truth_label: "Verdad",
    puzzle_create_truth_placeholder: "La verdad detrás del puzzle (visible solo para creadores y usuarios que lo hayan resuelto)",
    puzzle_create_truth_hidden: "Haz clic en \"Mostrar verdad\" para ver la respuesta",
    puzzle_create_show_truth: "Mostrar verdad",
    puzzle_create_show_truth_dialog_title: "Confirmar ver verdad",
    puzzle_create_show_truth_dialog_description: "Después de ver la verdad, ya no podrás experimentar este puzzle como un retador. ¿Estás seguro de que quieres verla?",
    puzzle_create_show_truth_confirm: "Confirmar ver",
    puzzle_create_challenge: "Probar desafío",
    puzzle_create_try_self: "Probar yo mismo",
    puzzle_create_regenerate: "Regenerar",
    puzzle_create_publish: "Enviar puzzle",
    puzzle_create_ai_fill: "Creación inteligente",
    puzzle_create_ai_fill_free: "Gratis esta vez",
    puzzle_create_ai_fill_failed: "Error en la generación de IA",
    puzzle_create_ai_mode_title: "Creación inteligente",
    puzzle_create_ai_mode_fill: "Autocompletar",
    puzzle_create_ai_mode_fill_desc: "Solo completar campos vacíos",
    puzzle_create_ai_mode_optimize: "Optimización completa",
    puzzle_create_ai_mode_optimize_desc: "Optimizar basado en contenido existente",
    puzzle_create_ai_extra_prompt: "Indicación extra (opcional)",
    puzzle_create_ai_extra_prompt_placeholder: "Ej.: Más terrorífico, agregar un campus...",
    lantern_brewing: "Elaborando tu misterio…",
    lantern_drag_hint: "Mueve la luz · Descubre pistas",
    lantern_waiting: "Preparando el misterio…",
    lantern_ready: "Misterio listo",
    lantern_gen_failed: "Error de generación\nInténtalo de nuevo más tarde",
    lantern_back: "Volver",
    puzzle_create_targets_label: "Objetivos",
    puzzle_create_add_target: "Añadir objetivo",
    puzzle_create_origin_label: "Origen",
    puzzle_create_origin_original: "Original",
    puzzle_create_origin_repost: "Republicado",
    puzzle_create_author_name: "Autor original",
    puzzle_create_author_name_placeholder: "Introduce el nombre del autor original",
    puzzle_create_creating: "Enviando...",
    puzzle_create_edit_title: "Editar puzzle",
    puzzle_create_save_changes: "Guardar cambios",
    puzzle_create_publish_success_title: "Enviado con éxito",
    puzzle_create_publish_success_message: "Puzzle enviado con éxito, en espera de revisión",
    puzzle_create_publish_success_try: "Probar ahora",
    puzzle_create_publish_success_back: "Volver al inicio",
    puzzle_create_publish_failed: "Error al enviar, por favor intenta de nuevo",
    puzzle_create_difficulty: "Dificultad",
    puzzle_create_tags: "Etiquetas",
    puzzle_create_tags_hint: "Opcional, máx. 3",
    puzzle_create_preview: "Vista previa",
    puzzle_create_collapse: "Colapsar",
    puzzle_create_expand: "Expandir vista previa",
    puzzle_create_ready: "Todos los campos obligatorios están completos",
    puzzle_create_incomplete: "Por favor completa todos los campos obligatorios",
    // puzzles_list
    puzzle_list_title: "Lista de puzzles",
    puzzle_list_empty_title: "Aún no has resuelto ningún puzzle",
    puzzle_list_empty_description: "¡Elige un puzzle para comenzar a resolver!",
    puzzle_list_empty_button: "Comenzar a resolver",
    puzzle_list_active: "En progreso",
    puzzle_list_completed: "Completado",
    puzzle_list_delete_success: "Eliminado exitosamente",
    puzzle_list_delete_failed: "Error al eliminar",
    puzzle_delete_confirm_title: "¿Eliminar este puzzle?",
    puzzle_delete_confirm_description: "El puzzle se ocultará de tu lista y de las páginas públicas. Actualmente no se puede restaurar en la Web.",
    puzzle_delete_confirm_action: "Eliminar puzzle",
    puzzle_list_loading: "Revisando expedientes...",
    // recharge
    recharge_title: "Centro de recarga",
    recharge_insufficient_balance: "Saldo insuficiente, recarga por favor",
    recharge_balance: "Saldo actual",
    recharge_balance_label: "Scenigma Points",
    recharge_select_amount: "Seleccionar monto de recarga",
    recharge_selected: "Seleccionado",
    recharge_confirm: "Confirmar recarga",
    recharge_processing: "Procesando...",
    recharge_confirm_amount: "Confirmar recarga",
    recharge_subscribed: "Suscrito",
    recharge_back: "Volver",
    recharge_launching_payment: "Procesando pago...",
    recharge_verifying: "Verificando compra...",
    recharge_subscription_section: "Suscripción actual",
    recharge_sp_unit: "SP",
    recharge_sub_name: "Scenigma Detective Lite",
    recharge_sub_desc: "600 SP/mes + bonus de registro",
    recharge_sub_period: "mes",
    recharge_sub_perk1: "600 SP mensuales",
    recharge_sub_perk2: "7 SP registro diario",
    recharge_basic_name: "Scenigma Detective Basic",
    recharge_basic_desc: "Nivel básico gratuito",
    recharge_basic_perk: "Registro 2SP/día",
    recharge_basic_price: "Gratis",
    profile_check_in_success_lite: "Registro: +7 SP (beneficio Lite activo)",
    recharge_desc_300: "Prueba rápida",
    recharge_desc_900: "Resolución ligera",
    recharge_desc_1500: "Maestro del puzzle",
    recharge_desc_3000: "Diversión detectivesca",
    // discover
    discover_title: "Descubrir puzzles",
    discover_pickup_title: "Destacados",
    discover_new: "Nuevo",
    discover_latest: "Más reciente",
    discover_hot_today: "Popular hoy",
    discover_hot_week: "Popular esta semana",
    discover_login_warning: "Por favor inicia sesión primero~",
    discover_loading: "Buscando pistas...",
    // profile
    profile_title: "Perfil",
    profile_not_logged_in: "No has iniciado sesión",
    profile_not_logged_in_description: "Inicia sesión para ver tus datos personales y guardar el progreso de los puzzles",
    profile_login_now: "Iniciar sesión ahora",
    profile_avatar_alt: "Avatar del usuario",
    profile_coins: "Scenigma Points",
    coins_unit: "SP",
    profile_recharge: "Recargar",
    profile_check_in: "Registro diario",
    profile_check_in_success: "Registro: +2 SP",
    profile_check_in_already: "Ya te registraste hoy",
    profile_network_error: "Error de red",
    profile_tab_created: "Mis creaciones",
    profile_tab_liked: "Mis favoritos",
    profile_empty_created_title: "Aún no has creado ningún puzzle",
    profile_empty_created_description: "Crea tu primer puzzle y compártelo con todos",
    profile_create_puzzle: "Crear puzzle",
    profile_empty_liked_title: "Aún no tienes puzzles favoritos",
    profile_empty_liked_description: "Ve a Descubrir para explorar más puzzles interesantes",
    profile_go_discover: "Ir a descubrir",
    profile_edit_nickname_title: "Editar apodo",
    profile_edit_nickname_description: "Por favor ingresa un nuevo apodo (máximo 12 caracteres)",
    profile_edit_nickname_placeholder: "Por favor ingresa el apodo",
    profile_edit_nickname_max: "El apodo no puede exceder 12 caracteres",
    profile_edit_nickname_saved: "Apodo actualizado",
    profile_edit_nickname_failed: "Error al actualizar apodo, se restauró el apodo original",
    profile_edit_nickname_cancel: "Cancelar",
    profile_edit_nickname_save: "Guardar",
    profile_avatar_upload_error: "Por favor selecciona un archivo de imagen",
    profile_avatar_size_error: "El tamaño de la imagen no puede exceder 5MB",
    profile_avatar_updated: "Avatar actualizado",
    // puzzle-card
    puzzle_card_publish: "Publicar",
    puzzle_card_reviewing: "En revisión",
    puzzle_card_rejected: "Violación",
    puzzle_card_completed: "Completado",
    puzzle_card_publish_failed: "Error al publicar, por favor intenta de nuevo",
    puzzle_card_publish_retry: "Error al publicar, por favor intenta de nuevo",
    puzzle_card_submitted_review: "Enviado para revisión",
    puzzle_card_original: "Original",
    puzzle_card_repost: "Republicar",
    puzzle_card_anonymous: "Anónimo",
    puzzle_card_author_default: "El Enigma",
    puzzle_card_new_this_week: "Nuevo esta semana",
    puzzle_card_solved_count: "resuelto",
    // settings
    settings_title: "Configuración",
    settings_language: "Configuración de idioma",
    settings_privacy_policy: "Política de privacidad",
    settings_terms_of_service: "Términos de Servicio",
    settings_logout: "Cerrar sesión",
    settings_logout_confirm_title: "Confirmar cierre de sesión",
    settings_logout_confirm_description: "Después de cerrar sesión, no podrás acceder a tus datos personales y necesitarás iniciar sesión nuevamente.",
    settings_logout_confirm_cancel: "Cancelar",
    settings_logout_confirm_action: "Confirmar cierre de sesión",
    settings_logout_success: "Sesión cerrada exitosamente",
    settings_discord_title: "Únete a nuestro Discord",
    settings_discord_desc: "Comparte comentarios y recibe las últimas noticias",
    settings_discord_join: "Unirse",
    settings_logout_failed: "Error al cerrar sesión",
    settings_delete_account: "Eliminar cuenta",
    settings_delete_account_confirm_title: "Confirmar eliminación de cuenta",
    settings_delete_account_confirm_description: "Eliminar la cuenta eliminará permanentemente todo el contenido asociado (perfil de cuenta, incluidos los datos de rompecabezas publicados). La eliminación será revisada y confirmada por el personal de atención al cliente, se espera que se complete en 14 días hábiles. Se le notificará por correo electrónico cuando se ejecute la eliminación. Durante este proceso, puede cancelar la eliminación de la cuenta en cualquier momento iniciando sesión nuevamente.",
    settings_delete_account_confirm_cancel: "Cancelar",
    settings_delete_account_confirm_action: "Confirmar eliminación",
    settings_delete_account_success: "Solicitud de eliminación de cuenta enviada",
    settings_delete_account_failed: "Error al enviar la solicitud de eliminación de cuenta",
    settings_delete_account_network_error: "Error de red, por favor intente nuevamente",
    settings_theme: "Tema",
    settings_theme_light: "Claro",
    settings_theme_dark: "Oscuro",
    settings_preferences: "Ajustes y preferencias",
    topbar_login_account: "Iniciar sesión",
    topbar_login_bonus: "Empieza a razonar libremente",
    topbar_community_join: "Unirse a la comunidad",
    topbar_community_qq: "Grupo QQ",
    topbar_community_pending: "Enlace del grupo no configurado",
    settings_section_appearance: "Apariencia",
    settings_section_community: "Comunidad",
    settings_section_account: "Cuenta",
    settings_redeem_code: "Código de canje",
    settings_redeem_code_desc: "Introduce un código de evento o comunidad para recibir SP",
    settings_redeem_code_placeholder: "Introduce el código",
    settings_redeem_code_action: "Canjear",
    settings_redeem_code_redeeming: "Canjeando...",
    settings_redeem_code_success: "Canje correcto: {amount} SP",
    settings_redeem_code_invalid: "Código no válido o caducado",
    settings_redeem_code_already_redeemed: "Ya has canjeado este código",
    settings_redeem_code_network_error: "No se pudo canjear. Inténtalo de nuevo",
    login_account_deletion_title: "Solicitud de eliminación de cuenta",
    login_account_deletion_description: "Su cuenta tiene una solicitud de eliminación pendiente. Haga clic en 'Continuar' para iniciar sesión y cancelar la solicitud de eliminación de cuenta.",
    login_account_deletion_continue: "Continuar",
    login_account_deletion_cancel: "Cancelar",
    login_account_deletion_revoke_success: "Solicitud de eliminación de cuenta cancelada",
    login_account_deletion_revoke_failed: "Error al cancelar la solicitud de eliminación de cuenta",
    login_account_deletion_network_error: "Error de red, por favor inicie sesión nuevamente",
    // login tutorial
    tutorial_welcome: "Bienvenido a Puzzles Situacionales, juegos de puzzles potenciados por IA.",
    tutorial_ask_familiar: "Antes de comenzar, permíteme preguntarte:\n¿Estás familiarizado con los juegos de puzzles situacionales?",
    tutorial_response_yes: "Bien, déjame presentarte rápidamente cómo usar esta aplicación.",
    tutorial_response_no: "¡Bien! Los juegos de puzzles situacionales funcionan así: una parte hace preguntas basadas en el 'escenario del puzzle', y la otra parte responde 'sí', 'no' o 'irrelevante' basándose en la 'verdad', hasta que se revele la verdad.",
    tutorial_intro_demo: "A continuación, te daré un escenario de puzzle. Por favor elige las preguntas que quieres hacer y yo responderé. Como este es un tutorial de demostración, te proporcionaré opciones directamente; en el juego real, puedes escribir cualquier pregunta que quieras hacer.",
    tutorial_congrats: "¡Felicidades! ¡Básicamente has aprendido a jugar puzzles situacionales! Ahora, inicia sesión en tu cuenta y hagamos más resolución de puzzles situacionales juntos! Permíteme darte la bienvenida nuevamente:",
    tutorial_puzzle_demo: "Un hombre ciego entra a un restaurante y pide sopa de tortuga. Después de tomar un sorbo, de repente grita de dolor, sale del restaurante y se suicida. ¿Puedes adivinar cuál es la verdad detrás de esto?",
    tutorial_option_1: "¿Fue envenenado?",
    tutorial_option_2: "¿Recordó algo?",
    tutorial_option_3: "¿Estuvo alguna vez varado en una isla desierta con un compañero, casi muriendo de hambre, cuando bebió 'sopa de tortuga' que le dio su compañero?",
    tutorial_option_4: "¿Recordó una tortuga que una vez tuvo?",
    tutorial_option_5: "¿Se dio cuenta de que la 'sopa de tortuga' que bebió en realidad estaba hecha de la carne de su compañero, por eso sobrevivió hasta el rescate, mientras que su compañero desafortunadamente murió?",
    tutorial_got_it: "Entendido",
    tutorial_answer_yes: "Sí",
    tutorial_answer_no: "No",
    // navigation
    // themes
    theme_label: "Tema",
    theme_all: "Todos",
    theme_honkaku: "Honkaku",
    theme_henkaku: "Henkaku",
    theme_suspense: "Suspenso",
    theme_casual: "Casual",
    theme_hardcore: "Hardcore",
    theme_horror: "Horror",
    theme_heartwarming: "Conmovedor",
    // discover sort
    discover_sort_latest: "Más reciente",
    discover_sort_hot_today: "Popular hoy",
    discover_sort_hot_week: "Popular esta semana",
    // discover filter & sort (web)
    discover_filter_all: "Todos",
    discover_filter_hot: "Popular",
    discover_filter_latest: "Reciente",
    discover_difficulty_easy: "Fácil",
    discover_difficulty_medium: "Medio",
    discover_difficulty_hard: "Difícil",
    discover_sortby_composite: "Compuesto",
    discover_sortby_newest: "Más nuevo",
    discover_sortby_most_liked: "Más gustados",
    discover_sortby_most_played: "Más jugados",
    discover_no_result: "No se encontraron puzzles que coincidan",
    discover_puzzle_count: "puzzles",
    nav_puzzles: "Puzzles",
    nav_discover: "Descubrir",
    nav_profile: "Perfil",
    nav_create: "Crear Puzzle",
    nav_recharge: "Recargar",
    nav_settings: "Configuración",
    nav_my_puzzles: "Mis Puzzles",
    sidebar_investigation: "Investigación",
    sidebar_case_files: "Expedientes",
    sidebar_account: "Cuenta",
    sidebar_tagline: "Acertijos de pensamiento lateral"
};

// 泰语
export const thTHTextData: TextDataType = {
    theme_quirky: "แนวแปลก",
    puzzle_quirky_hint: "ปริศนาแนวแปลกอาจต้องใช้จินตนาการ~ สนุกกับการไขปริศนาให้เต็มที่!",
    login_title: "ยินดีต้อนรับสู่ Scenigma",
    login_subtitle: "กรอกอีเมลและรหัสผ่านเพื่อเข้าสู่ระบบ หากไม่มีบัญชี จะสร้างบัญชีใหม่ให้อัตโนมัติ",
    login_email_title: "อีเมล",
    login_email_continue: "ดำเนินการต่อ",
    login_email_miss_toast: "กรุณากรอกอีเมล",
    login_otp_miss_toast: "กรุณากรอกรหัสยืนยัน",
    login_email_wrong_toast: "กรุณาตรวจสอบรูปแบบอีเมล",
    login_otp_send_toast: "ส่งรหัสยืนยันไปยังอีเมลของคุณแล้ว",
    login_loading: "กำลังเข้าสู่ระบบ...",
    login_fail_toast: "เข้าสู่ระบบล้มเหลว กรุณาลองอีกครั้ง",
    login_network_error: "เชื่อมต่อเครือข่ายล้มเหลว กรุณาตรวจสอบการเชื่อมต่อแล้วลองใหม่",
    login_otp_title: "รหัสยืนยัน",
    login_otp_continue: "เข้าสู่ระบบ",
    login_get_otp_button: "รับรหัส",
    login_otp_cd: "วินาที",
    login_quick_use: "เล่นด่วน",
    login_guest: "แค่ดูก่อน",
    login_divider: "หรือ",
    login_email_placeholder: "m@example.com",
    login_as_apple: "ดำเนินการต่อด้วย Apple",
    login_as_google: "ดำเนินการต่อด้วย Google",
    login_tips: "จะลงทะเบียนบัญชีโดยอัตโนมัติเมื่อเข้าสู่ระบบครั้งแรก\nการใช้งานต่อหมายความว่าคุณยอมรับข้อกำหนดการใช้งานและนโยบายความเป็นส่วนตัว",
    login_sign_in: "เข้าสู่ระบบ",
    login_sign_up: "สมัครสมาชิก (รับ 50 เหรียญทันที!)",
    login_welcome_back: "ยินดีต้อนรับกลับ ",
    login_hero_tagline: "ทุกปริศนามีความจริงซ่อนอยู่ในเงามืด",
    login_hero_desc: "การไขปริศนาด้วย AI\nถามคำถาม สำรวจ และเปิดเผยความจริง",
    login_brand: "Scenigma",
    login_access_terminal: "เข้าสู่ระบบ",
    app_play: "เล่น",
    app_share: "แชร์",
    // puzzle_chat
    puzzle_soup_label: "ปริศนา",
    puzzle_publish: "เผยแพร่",
    puzzle_reviewing: "กำลังตรวจสอบ",
    puzzle_like: "ถูกใจ",
    puzzle_input_placeholder: "กรอกคำถามหรือการคาดเดา...",
    puzzle_report_title: "รายงานปริศนา",
    puzzle_report_description: "กรุณาเลือกเหตุผลในการรายงานและกรอกข้อมูลรายละเอียด",
    puzzle_report_reason_label: "เหตุผลในการรายงาน",
    puzzle_report_extra_label: "หมายเหตุเพิ่มเติม (ไม่บังคับ)",
    puzzle_report_extra_placeholder: "กรุณาอธิบายเหตุผลโดยละเอียด...",
    puzzle_report_cancel: "ยกเลิก",
    puzzle_report_submit: "ยืนยัน",
    puzzle_report_submitting: "กำลังส่ง...",
    puzzle_report_confirm: "ยืนยัน",
    puzzle_report_success: "ส่งรายงานสำเร็จแล้ว! เราจะดำเนินการโดยเร็วที่สุด",
    puzzle_publish_failed: "การเผยแพร่ล้มเหลว กรุณาลองอีกครั้ง",
    puzzle_publish_retry: "การเผยแพร่ล้มเหลว กรุณาลองอีกครั้ง",
    puzzle_submitted_review: "ส่งเพื่อตรวจสอบแล้ว",
    puzzle_like_failed: "การถูกใจล้มเหลว กรุณาลองอีกครั้ง",
    puzzle_unlike_failed: "การยกเลิกถูกใจล้มเหลว กรุณาลองอีกครั้ง",
    puzzle_report_reason_porn: "เนื้อหาลามก",
    puzzle_report_reason_violence: "เนื้อหาความรุนแรงมากเกินไป",
    puzzle_report_reason_politics: "เนื้อหาทางการเมือง",
    puzzle_report_reason_illegal: "เนื้อหาผิดกฎหมาย",
    puzzle_report_reason_infringement: "ละเมิดลิขสิทธิ์",
    puzzle_report_reason_other: "อื่นๆ",
    puzzle_clues_empty_hint: "ถามคำถามเพื่อรับคำใบ้",
    puzzle_clues_no_eliminated: "ยังไม่มีเบาะแสที่ถูกตัดออก",
    casefile_title: "แฟ้มคดี",
    casefile_subtitle: "Case File",
    casefile_complete: "เสร็จสิ้น",
    casefile_in_progress: "กำลังดำเนินการ",
    casefile_investigation: "การสืบสวน",
    casefile_goals: "เป้าหมาย",
    casefile_goals_count: "{achieved} จาก {total}",
    casefile_confirmed_yes: "ยืนยันแล้ว (YES)",
    casefile_eliminated_no: "ตัดออกแล้ว (NO)",
    puzzle_solve_hint: "แก้ปัญหาต่อไปนี้เพื่อไขปริศนาให้เสร็จ",
    puzzle_keypoint_murderer: "ผู้ฆ่า",
    puzzle_keypoint_method: "วิธี",
    puzzle_keypoint_motive: "แรงจูงใจ",
    puzzle_goals_hint: "ทำเป้าหมายสำคัญทั้งหมดให้สำเร็จเพื่อเปิดเผยคำตอบ",
    puzzle_truth_revealed_title: "ความจริงถูกเปิดเผย!",
    puzzle_truth_revealed_subtitle: "คุณแก้ปริศนาได้ทั้งหมดแล้ว!",
    puzzle_truth_view_full: "ดูคำตอบเต็ม",
    puzzle_truth_answer_label: "คำตอบ:",
    puzzle_truth_back_list: "กลับไปรายการ",
    next_puzzle_title: "คดีถัดไป",
    next_puzzle_hook_label: "แอบดูโจทย์",
    next_puzzle_start: "เริ่มข้อถัดไป",
    next_puzzle_start_countdown: "เริ่มข้อถัดไป ({s})",
    next_puzzle_ai_generate: "ให้ AI สร้างข้อใหม่",
    next_puzzle_loading: "กำลังค้นหาคดีถัดไป…",
    next_puzzle_empty: "ยังไม่มีคดีใหม่ ให้ AI สร้างสักข้อสิ",
    giveup_title: "ติดอยู่ใช่ไหม?",
    giveup_desc: "ก่อนจะไป ลองสิ่งเหล่านี้ดู",
    giveup_switch_puzzle: "ลองข้ออื่น",
    giveup_keep_playing: "เล่นต่อ",
    giveup_switch_empty: "ไม่พบข้อที่เหมาะกว่านี้",
    giveup_switching: "กำลังหาข้ออื่นให้คุณ…",
    giveup_leave: "ออก",
    giveup_answer_title: "ต้องการดูคำตอบไหม?",
    giveup_answer_subtitle: "บางครั้งปัญหาไม่ได้อยู่ที่การให้เหตุผลของคุณ",
    giveup_stat_solved: "เป้าหมายที่แก้ได้",
    giveup_stat_rounds: "คำถาม",
    giveup_reveal_free: "ดูคำตอบฟรี",
    giveup_free_daily_note: "ครั้งแรกวันนี้ฟรี",
    giveup_reveal_prefix: "ดูคำตอบในราคา",
    giveup_deducted_prefix: "ส่วนลดแล้ว",
    giveup_deducted_suffix: " SP",
    giveup_answer_label: "ความจริง",
    giveup_answer_closure: "เรื่องราวที่เกิดขึ้นจริงคือ",
    giveup_answer_done: "เข้าใจแล้ว",
    giveup_answer_failed: "ไม่สามารถเปิดเผยคำตอบได้ โปรดลองอีกครั้ง",
    giveup_reward_label: "ประหยัด",
    giveup_reveal_action: "ดูคำตอบ",
    giveup_leave_mute: "ออก (ไม่ต้องถามอีกวันนี้)",
    // chat page
    chat_load_failed: "โหลดการสนทนาล้มเหลว",
    chat_send_failed: "ส่งล้มเหลว กรุณาลองใหม่",
    chat_loading: "กำลังโหลดแฟ้มคดี...",
    chat_not_found: "ไม่พบคดี",
    chat_ended: "การสนทนาสิ้นสุดแล้ว",
    chat_enter_hint: "กด Enter เพื่อส่ง, Shift + Enter เพื่อขึ้นบรรทัดใหม่",
    chat_progress: "ความคืบหน้า",
    chat_stat_questions: "คำถาม",
    chat_stat_duration: "ระยะเวลา",
    chat_stat_goals: "เป้าหมาย",
    chat_stat_likes: "ถูกใจ",
    chat_answer_yes: "ใช่",
    chat_answer_no: "ไม่",
    chat_answer_both: "ใช่และไม่",
    chat_answer_unrelated: "ไม่เกี่ยวข้อง",
    chat_case_closed: "คดีปิดแล้ว",
    // puzzle_create
    puzzle_create_title: "สร้างปริศนา",
    puzzle_create_ai_tab: "สร้างด้วย AI",
    puzzle_create_manual_tab: "สร้างเอง",
    puzzle_create_ai_title: "สืบสวนปริศนาหนึ่งบท",
    puzzle_create_ai_description: "ผู้ช่วยนักสืบ AI จะสืบสวนปริศนาต้นฉบับให้คุณ เลือกธีม จุดตะเกียงเพื่อสืบสวน และสำรวจเรื่องราวในความมืด",
    puzzle_create_ai_button: "เริ่มสืบสวน",
    puzzle_create_generating: "กำลังสร้าง...",
    puzzle_create_title_label: "ชื่อปริศนา",
    puzzle_create_title_placeholder: "ตั้งชื่อให้ปริศนาของคุณ",
    puzzle_create_soup_label: "เรื่องราวต้นฉบับ",
    puzzle_create_soup_placeholder: "อธิบายสถานการณ์เริ่มต้นของปริศนา (ยิ่งเรียบง่ายและน่าตื่นเต้นยิ่งดี)",
    puzzle_create_truth_label: "ความจริง",
    puzzle_create_truth_placeholder: "ความจริงของปริศนา (เห็นได้เฉพาะผู้สร้างและผู้ใช้ที่แก้ได้)",
    puzzle_create_truth_hidden: "คลิก \"แสดงความจริง\" เพื่อดูคำตอบ",
    puzzle_create_show_truth: "แสดงความจริง",
    puzzle_create_show_truth_dialog_title: "ยืนยันการดูความจริง",
    puzzle_create_show_truth_dialog_description: "หลังจากดูความจริงแล้ว คุณจะไม่สามารถเล่นปริศนานี้ในฐานะผู้ท้าทายได้อีก คุณแน่ใจหรือไม่ว่าต้องการดู?",
    puzzle_create_show_truth_confirm: "ยืนยันการดู",
    puzzle_create_challenge: "ลองท้าทาย",
    puzzle_create_try_self: "ลองเอง",
    puzzle_create_regenerate: "สร้างใหม่",
    puzzle_create_publish: "ส่งปริศนา",
    puzzle_create_ai_fill: "สร้างอัจฉริยะ",
    puzzle_create_ai_fill_free: "ฟรีครั้งนี้",
    puzzle_create_ai_fill_failed: "การสร้าง AI ล้มเหลว",
    puzzle_create_ai_mode_title: "สร้างอัจฉริยะ",
    puzzle_create_ai_mode_fill: "เติมอัตโนมัติ",
    puzzle_create_ai_mode_fill_desc: "เติมเฉพาะช่องที่ยังว่าง",
    puzzle_create_ai_mode_optimize: "ปรับปรุงทั้งหมด",
    puzzle_create_ai_mode_optimize_desc: "ปรับปรุงจากเนื้อหาที่มีอยู่",
    puzzle_create_ai_extra_prompt: "คำแนะนำเพิ่มเติม (ไม่บังคับ)",
    puzzle_create_ai_extra_prompt_placeholder: "เช่น: น่ากลัวกว่านี้, เพิ่มฉากในมหาวิทยาลัย...",
    lantern_brewing: "กำลังสร้างปริศนา…",
    lantern_drag_hint: "ลากแสง · สำรวจเบาะแส",
    lantern_waiting: "กำลังเตรียมปริศนา…",
    lantern_ready: "ปริศนาพร้อมแล้ว",
    lantern_gen_failed: "สร้างล้มเหลว\nกรุณาลองอีกครั้งภายหลัง",
    lantern_back: "กลับ",
    puzzle_create_targets_label: "เป้าหมาย",
    puzzle_create_add_target: "เพิ่มเป้าหมาย",
    puzzle_create_origin_label: "แหล่งที่มา",
    puzzle_create_origin_original: "ต้นฉบับ",
    puzzle_create_origin_repost: "นำมาแชร์",
    puzzle_create_author_name: "ชื่อผู้เขียนต้นฉบับ",
    puzzle_create_author_name_placeholder: "กรอกชื่อผู้เขียนต้นฉบับ",
    puzzle_create_creating: "กำลังส่ง...",
    puzzle_create_edit_title: "แก้ไขปริศนา",
    puzzle_create_save_changes: "บันทึกการเปลี่ยนแปลง",
    puzzle_create_publish_success_title: "ส่งสำเร็จ",
    puzzle_create_publish_success_message: "ส่งปริศนาสำเร็จแล้ว รอการตรวจสอบ",
    puzzle_create_publish_success_try: "ลองเลย",
    puzzle_create_publish_success_back: "กลับหน้าหลัก",
    puzzle_create_publish_failed: "การส่งล้มเหลว กรุณาลองอีกครั้ง",
    puzzle_create_difficulty: "ระดับความยาก",
    puzzle_create_tags: "แท็ก",
    puzzle_create_tags_hint: "ไม่บังคับ สูงสุด 3",
    puzzle_create_preview: "ตัวอย่าง",
    puzzle_create_collapse: "ย่อ",
    puzzle_create_expand: "ขยายตัวอย่าง",
    puzzle_create_ready: "กรอกข้อมูลที่จำเป็นครบแล้ว พร้อมเผยแพร่",
    puzzle_create_incomplete: "กรุณากรอกข้อมูลที่จำเป็นให้ครบ",
    // puzzles_list
    puzzle_list_title: "รายการปริศนา",
    puzzle_list_empty_title: "ยังไม่ได้แก้ปริศนา",
    puzzle_list_empty_description: "เลือกปริศนาเพื่อเริ่มแก้!",
    puzzle_list_empty_button: "เริ่มแก้",
    puzzle_list_active: "กำลังดำเนินการ",
    puzzle_list_completed: "เสร็จสิ้น",
    puzzle_list_delete_success: "ลบสำเร็จ",
    puzzle_list_delete_failed: "การลบล้มเหลว",
    puzzle_delete_confirm_title: "ลบปริศนานี้หรือไม่",
    puzzle_delete_confirm_description: "ปริศนานี้จะถูกซ่อนจากรายการและหน้าสาธารณะของคุณ และยังไม่สามารถกู้คืนบนเว็บได้ในขณะนี้",
    puzzle_delete_confirm_action: "ลบปริศนา",
    puzzle_list_loading: "กำลังตรวจสอบแฟ้มคดี...",
    // recharge
    recharge_title: "ศูนย์เติมเงิน",
    recharge_insufficient_balance: "ยอดเงินไม่เพียงพอ กรุณาเติมเงิน",
    recharge_balance: "ยอดเงินคงเหลือ",
    recharge_balance_label: "Scenigma Points",
    recharge_select_amount: "เลือกจำนวนเงินเติม",
    recharge_selected: "เลือกแล้ว",
    recharge_confirm: "ยืนยันการเติมเงิน",
    recharge_processing: "กำลังดำเนินการ...",
    recharge_confirm_amount: "ยืนยันการเติมเงิน",
    recharge_subscribed: "สมัครแล้ว",
    recharge_back: "กลับ",
    recharge_launching_payment: "กำลังดำเนินการชำระเงิน...",
    recharge_verifying: "กำลังตรวจสอบการซื้อ...",
    recharge_subscription_section: "การสมัครสมาชิกปัจจุบัน",
    recharge_sp_unit: "SP",
    recharge_sub_name: "Scenigma Detective Lite",
    recharge_sub_desc: "600 SP/เดือน + โบนัสเช็คอิน",
    recharge_sub_period: "เดือน",
    recharge_sub_perk1: "600 SP ต่อเดือน",
    recharge_sub_perk2: "เช็คอินรับ 7 SP ต่อวัน",
    recharge_basic_name: "Scenigma Detective Basic",
    recharge_basic_desc: "ระดับพื้นฐานฟรี",
    recharge_basic_perk: "เช็คอิน 2SP/วัน",
    recharge_basic_price: "ฟรี",
    profile_check_in_success_lite: "เช็คอิน: +7 SP (สิทธิ์ Lite)",
    recharge_desc_300: "ทดลองใช้",
    recharge_desc_900: "ไขปริศนาเบาๆ",
    recharge_desc_1500: "นักไขปริศนา",
    recharge_desc_3000: "นักสืบสุดคุ้ม",
    // discover
    discover_title: "ค้นหาปริศนา",
    discover_pickup_title: "คัดสรรพิเศษ",
    discover_new: "สร้างใหม่",
    discover_latest: "ล่าสุด",
    discover_hot_today: "ยอดนิยมวันนี้",
    discover_hot_week: "ยอดนิยมสัปดาห์นี้",
    discover_login_warning: "กรุณาเข้าสู่ระบบก่อน~",
    discover_loading: "กำลังค้นหาเบาะแส...",
    // profile
    profile_title: "โปรไฟล์",
    profile_not_logged_in: "ยังไม่ได้เข้าสู่ระบบ",
    profile_not_logged_in_description: "เข้าสู่ระบบเพื่อดูข้อมูลส่วนตัวและบันทึกความคืบหน้าของปริศนา",
    profile_login_now: "เข้าสู่ระบบตอนนี้",
    profile_avatar_alt: "รูปโปรไฟล์ผู้ใช้",
    profile_coins: "Scenigma Points",
    coins_unit: "SP",
    profile_recharge: "เติมเงิน",
    profile_check_in: "เช็คอิน",
    profile_check_in_success: "เช็คอิน: +2 SP",
    profile_check_in_already: "เช็คอินวันนี้แล้ว",
    profile_network_error: "ข้อผิดพลาดเครือข่าย",
    profile_tab_created: "ที่ฉันสร้าง",
    profile_tab_liked: "ที่ฉันถูกใจ",
    profile_empty_created_title: "ยังไม่ได้สร้างปริศนา",
    profile_empty_created_description: "สร้างปริศนาแรกของคุณและแชร์กับทุกคน",
    profile_create_puzzle: "สร้างปริศนา",
    profile_empty_liked_title: "ยังไม่มีปริศนาที่ถูกใจ",
    profile_empty_liked_description: "ไปที่ค้นหาเพื่อสำรวจปริศนาที่น่าสนใจเพิ่มเติม",
    profile_go_discover: "ไปค้นหา",
    profile_edit_nickname_title: "แก้ไขชื่อเล่น",
    profile_edit_nickname_description: "กรุณากรอกชื่อเล่นใหม่ (สูงสุด 12 ตัวอักษร)",
    profile_edit_nickname_placeholder: "กรุณากรอกชื่อเล่น",
    profile_edit_nickname_max: "ชื่อเล่นต้องไม่เกิน 12 ตัวอักษร",
    profile_edit_nickname_saved: "อัปเดตชื่อเล่นแล้ว",
    profile_edit_nickname_failed: "อัปเดตชื่อเล่นล้มเหลว ได้คืนชื่อเล่นเดิมแล้ว",
    profile_edit_nickname_cancel: "ยกเลิก",
    profile_edit_nickname_save: "บันทึก",
    profile_avatar_upload_error: "กรุณาเลือกไฟล์รูปภาพ",
    profile_avatar_size_error: "ขนาดรูปภาพต้องไม่เกิน 5MB",
    profile_avatar_updated: "อัปเดตรูปโปรไฟล์แล้ว",
    // puzzle-card
    puzzle_card_publish: "เผยแพร่",
    puzzle_card_reviewing: "กำลังตรวจสอบ",
    puzzle_card_rejected: "ผิดกฎ",
    puzzle_card_completed: "เสร็จสิ้น",
    puzzle_card_publish_failed: "การเผยแพร่ล้มเหลว กรุณาลองอีกครั้ง",
    puzzle_card_publish_retry: "การเผยแพร่ล้มเหลว กรุณาลองอีกครั้ง",
    puzzle_card_submitted_review: "ส่งเพื่อตรวจสอบแล้ว",
    puzzle_card_original: "ต้นฉบับ",
    puzzle_card_repost: "แชร์ต่อ",
    puzzle_card_anonymous: "ไม่ระบุชื่อ",
    puzzle_card_author_default: "ปริศนา",
    puzzle_card_new_this_week: "ใหม่สัปดาห์นี้",
    puzzle_card_solved_count: "คนแก้ปริศนา",
    // settings
    settings_title: "การตั้งค่า",
    settings_language: "การตั้งค่าภาษา",
    settings_privacy_policy: "นโยบายความเป็นส่วนตัว",
    settings_terms_of_service: "ข้อกำหนดการใช้งาน",
    settings_logout: "ออกจากระบบ",
    settings_logout_confirm_title: "ยืนยันการออกจากระบบ",
    settings_logout_confirm_description: "หลังจากออกจากระบบแล้ว คุณจะไม่สามารถเข้าถึงข้อมูลส่วนตัวได้ และต้องเข้าสู่ระบบอีกครั้ง",
    settings_logout_confirm_cancel: "ยกเลิก",
    settings_logout_confirm_action: "ยืนยันการออก",
    settings_logout_success: "ออกจากระบบสำเร็จ",
    settings_discord_title: "เข้าร่วม Discord",
    settings_discord_desc: "พูดคุยแสดงความคิดเห็นและรับข่าวสารล่าสุด",
    settings_discord_join: "เข้าร่วม",
    settings_logout_failed: "การออกจากระบบล้มเหลว",
    settings_delete_account: "ลบบัญชี",
    settings_delete_account_confirm_title: "ยืนยันการลบบัญชี",
    settings_delete_account_confirm_description: "การลบบัญชีจะลบเนื้อหาที่เกี่ยวข้องทั้งหมด (โปรไฟล์บัญชี รวมถึงข้อมูลปริศนาที่เผยแพร่) อย่างถาวร การลบจะได้รับการตรวจสอบและยืนยันโดยเจ้าหน้าที่บริการลูกค้า คาดว่าจะเสร็จสิ้นภายใน 14 วันทำการ คุณจะได้รับการแจ้งเตือนทางอีเมลเมื่อการลบถูกดำเนินการ ในระหว่างกระบวนการนี้ คุณสามารถยกเลิกการลบบัญชีได้ตลอดเวลาโดยการเข้าสู่ระบบอีกครั้ง",
    settings_delete_account_confirm_cancel: "ยกเลิก",
    settings_delete_account_confirm_action: "ยืนยันการลบ",
    settings_delete_account_success: "ส่งคำขอลบบัญชีแล้ว",
    settings_delete_account_failed: "ส่งคำขอลบบัญชีล้มเหลว",
    settings_delete_account_network_error: "เกิดปัญหาเครือข่าย กรุณาลองอีกครั้ง",
    settings_theme: "ธีม",
    settings_theme_light: "สว่าง",
    settings_theme_dark: "มืด",
    settings_preferences: "การตั้งค่าและความชอบ",
    topbar_login_account: "เข้าสู่ระบบ",
    topbar_login_bonus: "เริ่มการคิดอย่างอิสระทันที",
    topbar_community_join: "เข้าร่วมชุมชน",
    topbar_community_qq: "กลุ่ม QQ",
    topbar_community_pending: "ยังไม่ได้ตั้งค่าลิงก์กลุ่ม",
    settings_section_appearance: "รูปลักษณ์",
    settings_section_community: "ชุมชน",
    settings_section_account: "บัญชี",
    settings_redeem_code: "รหัสแลกรางวัล",
    settings_redeem_code_desc: "กรอกรหัสกิจกรรมหรือชุมชนเพื่อรับ SP",
    settings_redeem_code_placeholder: "กรอกรหัส",
    settings_redeem_code_action: "แลกรางวัล",
    settings_redeem_code_redeeming: "กำลังแลก...",
    settings_redeem_code_success: "แลกรางวัลสำเร็จ: {amount} SP",
    settings_redeem_code_invalid: "รหัสไม่ถูกต้องหรือหมดอายุ",
    settings_redeem_code_already_redeemed: "คุณใช้รหัสนี้ไปแล้ว",
    settings_redeem_code_network_error: "แลกรางวัลไม่สำเร็จ โปรดลองอีกครั้ง",
    login_account_deletion_title: "คำขอลบบัญชี",
    login_account_deletion_description: "บัญชีของคุณมีการร้องขอการลบบัญชีที่รอดำเนินการ คลิก 'ดำเนินการต่อ' เพื่อเข้าสู่ระบบและยกเลิกคำขอลบบัญชี",
    login_account_deletion_continue: "ดำเนินการต่อ",
    login_account_deletion_cancel: "ยกเลิก",
    login_account_deletion_revoke_success: "ยกเลิกคำขอลบบัญชีแล้ว",
    login_account_deletion_revoke_failed: "ยกเลิกคำขอลบบัญชีล้มเหลว",
    login_account_deletion_network_error: "เกิดปัญหาเครือข่าย กรุณาเข้าสู่ระบบอีกครั้ง",
    // login tutorial
    tutorial_welcome: "ยินดีต้อนรับสู่ปริศนาสถานการณ์ ที่ขับเคลื่อนด้วย AI",
    tutorial_ask_familiar: "ก่อนเริ่มต้น ขอถามคุณ:\nคุณคุ้นเคยกับเกมปริศนาสถานการณ์หรือไม่?",
    tutorial_response_yes: "ดีครับ ให้ฉันแนะนำวิธีใช้แอปนี้อย่างรวดเร็ว",
    tutorial_response_no: "ดีครับ! เกมปริศนาสถานการณ์ทำงานแบบนี้: ฝ่ายหนึ่งถามคำถามตาม 'สถานการณ์ปริศนา' และอีกฝ่ายตอบ 'ใช่' 'ไม่ใช่' หรือ 'ไม่เกี่ยวข้อง' ตาม 'ความจริง' จนกว่าความจริงจะถูกเปิดเผย",
    tutorial_intro_demo: "ต่อไป ฉันจะให้สถานการณ์ปริศนาแก่คุณ กรุณาเลือกคำถามที่คุณต้องการถาม และฉันจะตอบ เนื่องจากนี่เป็นบทเรียนสาธิต ฉันจะให้ตัวเลือกโดยตรง ในเกมจริง คุณสามารถพิมพ์คำถามใดๆ ที่ต้องการถามได้",
    tutorial_congrats: "ยินดีด้วย! คุณได้เรียนรู้วิธีเล่นปริศนาสถานการณ์แล้ว! ตอนนี้ เข้าสู่ระบบบัญชีของคุณและมาแก้ปริศนาสถานการณ์เพิ่มเติมกัน! ให้ฉันต้อนรับคุณอีกครั้ง:",
    tutorial_puzzle_demo: "ชายตาบอดคนหนึ่งเข้าไปในร้านอาหารและสั่งซุปเต่า หลังจากดื่มหนึ่งคำ เขาก็ร้องด้วยความเจ็บปวด ออกจากร้านอาหารและฆ่าตัวตาย คุณสามารถเดาความจริงเบื้องหลังเรื่องนี้ได้ไหม?",
    tutorial_option_1: "เขาถูกวางยาพิษหรือไม่?",
    tutorial_option_2: "เขาจำอะไรบางอย่างได้หรือไม่?",
    tutorial_option_3: "เขาเคยติดอยู่บนเกาะร้างกับเพื่อน เกือบตายเพราะความหิว เมื่อเขาดื่ม 'ซุปเต่า' ที่เพื่อนให้มาหรือไม่?",
    tutorial_option_4: "เขาจำเต่าที่เคยเลี้ยงไว้ได้หรือไม่?",
    tutorial_option_5: "เขาตระหนักหรือไม่ว่า 'ซุปเต่า' ที่เขาดื่มนั้นทำจากเนื้อของเพื่อนจริงๆ นั่นเป็นเหตุผลที่เขารอดชีวิตจนได้รับการช่วยเหลือ ในขณะที่เพื่อนของเขาเสียชีวิตอย่างน่าเสียดาย",
    tutorial_got_it: "เข้าใจแล้ว",
    tutorial_answer_yes: "ใช่",
    tutorial_answer_no: "ไม่ใช่",
    // navigation
    // themes
    theme_label: "ธีม",
    theme_all: "ทั้งหมด",
    theme_honkaku: "ฮงคาคุ",
    theme_henkaku: "เฮ็นคาคุ",
    theme_suspense: "ระทึกขวัญ",
    theme_casual: "สบายๆ",
    theme_hardcore: "ฮาร์ดคอร์",
    theme_horror: "สยองเล็กน้อย",
    theme_heartwarming: "อบอุ่นหัวใจ",
    // discover sort
    discover_sort_latest: "ล่าสุด",
    discover_sort_hot_today: "ยอดนิยมวันนี้",
    discover_sort_hot_week: "ยอดนิยมสัปดาห์นี้",
    // discover filter & sort (web)
    discover_filter_all: "ทั้งหมด",
    discover_filter_hot: "ยอดนิยม",
    discover_filter_latest: "ล่าสุด",
    discover_difficulty_easy: "ง่าย",
    discover_difficulty_medium: "ปานกลาง",
    discover_difficulty_hard: "ยาก",
    discover_sortby_composite: "เรียงรวม",
    discover_sortby_newest: "ใหม่ล่าสุด",
    discover_sortby_most_liked: "ถูกใจมากสุด",
    discover_sortby_most_played: "เล่นมากสุด",
    discover_no_result: "ไม่พบปริศนาที่ตรงกับเงื่อนไข",
    discover_puzzle_count: "ปริศนา",
    nav_puzzles: "ปริศนา",
    nav_discover: "ค้นหา",
    nav_profile: "โปรไฟล์",
    nav_create: "สร้างปริศนา",
    nav_recharge: "เติมเงิน",
    nav_settings: "ตั้งค่า",
    nav_my_puzzles: "ปริศนาของฉัน",
    sidebar_investigation: "การสืบสวน",
    sidebar_case_files: "แฟ้มคดี",
    sidebar_account: "บัญชี",
    sidebar_tagline: "ปริศนาแนวคิดนอกกรอบ"
};

// 印尼语
export const idIDTextData: TextDataType = {
    theme_quirky: "Unik",
    puzzle_quirky_hint: "Teka-teki unik mungkin membutuhkan imajinasi~ Selamat menalar!",
    login_title: "Selamat datang di Scenigma.",
    login_subtitle: "Masukkan email dan kata sandi untuk masuk. Jika akun tidak ada, akun baru akan dibuat secara otomatis.",
    login_email_title: "Email",
    login_email_continue: "Lanjutkan",
    login_email_miss_toast: "Harap isi email terlebih dahulu",
    login_otp_miss_toast: "Harap isi kode verifikasi terlebih dahulu",
    login_email_wrong_toast: "Harap periksa format alamat email",
    login_otp_send_toast: "Kode verifikasi telah dikirim, silakan periksa email Anda",
    login_loading: "Sedang masuk...",
    login_fail_toast: "Login gagal, silakan coba lagi",
    login_network_error: "Koneksi jaringan gagal. Periksa koneksi Anda dan coba lagi.",
    login_otp_title: "Kode Verifikasi",
    login_otp_continue: "Masuk",
    login_get_otp_button: "Dapatkan Kode",
    login_otp_cd: "detik",
    login_quick_use: "Main Cepat",
    login_guest: "Lihat-lihat dulu",
    login_divider: "atau",
    login_email_placeholder: "m@example.com",
    login_as_apple: "Lanjutkan dengan Apple",
    login_as_google: "Lanjutkan dengan Google",
    login_tips: "Akun akan otomatis terdaftar saat masuk pertama kali.\nDengan melanjutkan penggunaan, Anda menyetujui Ketentuan Layanan dan Kebijakan Privasi kami.",
    login_sign_in: "Masuk",
    login_sign_up: "Daftar (Dapatkan 50 koin segera!)",
    login_welcome_back: "Selamat datang kembali, ",
    login_hero_tagline: "Setiap misteri menyimpan kebenaran yang menunggu terungkap",
    login_hero_desc: "Pemecahan misteri bertenaga AI.\nAjukan pertanyaan. Ungkap kebenarannya.",
    login_brand: "Scenigma",
    login_access_terminal: "Terminal Akses",
    app_play: "Main",
    app_share: "Bagikan",
    // puzzle_chat
    puzzle_soup_label: "Teka-teki",
    puzzle_publish: "Publikasikan",
    puzzle_reviewing: "Sedang Ditinjau",
    puzzle_like: "Suka",
    puzzle_input_placeholder: "Masukkan pertanyaan atau tebakan...",
    puzzle_report_title: "Laporkan Teka-teki",
    puzzle_report_description: "Harap pilih alasan laporan dan isi informasi detail",
    puzzle_report_reason_label: "Alasan Laporan",
    puzzle_report_extra_label: "Keterangan Tambahan (Opsional)",
    puzzle_report_extra_placeholder: "Harap jelaskan alasan secara detail...",
    puzzle_report_cancel: "Batal",
    puzzle_report_submit: "Konfirmasi",
    puzzle_report_submitting: "Mengirim...",
    puzzle_report_confirm: "Konfirmasi",
    puzzle_report_success: "Laporan berhasil dikirim, kami akan segera memprosesnya!",
    puzzle_publish_failed: "Publikasi gagal, harap coba lagi",
    puzzle_publish_retry: "Publikasi gagal, harap coba lagi",
    puzzle_submitted_review: "Telah Dikirim untuk Ditinjau",
    puzzle_like_failed: "Gagal menyukai, harap coba lagi",
    puzzle_unlike_failed: "Gagal membatalkan suka, harap coba lagi",
    puzzle_report_reason_porn: "Pornografi",
    puzzle_report_reason_violence: "Konten kekerasan yang berlebihan",
    puzzle_report_reason_politics: "Informasi politik",
    puzzle_report_reason_illegal: "Konten ilegal",
    puzzle_report_reason_infringement: "Pelanggaran hak cipta",
    puzzle_report_reason_other: "Lainnya",
    puzzle_clues_empty_hint: "Ajukan pertanyaan untuk mendapatkan petunjuk.",
    puzzle_clues_no_eliminated: "Belum ada petunjuk yang dieliminasi",
    casefile_title: "Berkas Kasus",
    casefile_subtitle: "Case File",
    casefile_complete: "Selesai",
    casefile_in_progress: "Sedang berlangsung",
    casefile_investigation: "Investigasi",
    casefile_goals: "Tujuan",
    casefile_goals_count: "{achieved} dari {total}",
    casefile_confirmed_yes: "Dikonfirmasi (YA)",
    casefile_eliminated_no: "Dieliminasi (TIDAK)",
    puzzle_solve_hint: "Selesaikan berikut untuk menyelesaikan teka-teki",
    puzzle_keypoint_murderer: "Pembunuh",
    puzzle_keypoint_method: "Metode",
    puzzle_keypoint_motive: "Motif",
    puzzle_goals_hint: "Selesaikan semua tujuan utama untuk membuka jawabannya",
    puzzle_truth_revealed_title: "Kebenaran Terungkap!",
    puzzle_truth_revealed_subtitle: "Anda berhasil memecahkan semua misteri!",
    puzzle_truth_view_full: "Lihat Jawaban Lengkap",
    puzzle_truth_answer_label: "Jawaban:",
    puzzle_truth_back_list: "Kembali ke Daftar",
    next_puzzle_title: "Kasus Berikutnya",
    next_puzzle_hook_label: "Intip Teka-teki",
    next_puzzle_start: "Mulai Berikutnya",
    next_puzzle_start_countdown: "Mulai Berikutnya ({s})",
    next_puzzle_ai_generate: "Buat dengan AI",
    next_puzzle_loading: "Mencari kasus berikutnya…",
    next_puzzle_empty: "Belum ada kasus baru, biar AI buatkan satu",
    giveup_title: "Buntu?",
    giveup_desc: "Sebelum pergi, coba salah satu ini",
    giveup_switch_puzzle: "Coba yang lain",
    giveup_keep_playing: "Lanjut bermain",
    giveup_switch_empty: "Tidak ada yang lebih cocok",
    giveup_switching: "Mencarikan yang lain untukmu…",
    giveup_leave: "Keluar",
    giveup_answer_title: "Ingin melihat jawabannya?",
    giveup_answer_subtitle: "Terkadang bukan penalaranmu yang bermasalah",
    giveup_stat_solved: "Target terpecahkan",
    giveup_stat_rounds: "Pertanyaan",
    giveup_reveal_free: "Lihat jawaban gratis",
    giveup_free_daily_note: "Pertama hari ini gratis",
    giveup_reveal_prefix: "Lihat dengan",
    giveup_deducted_prefix: "Diskon",
    giveup_deducted_suffix: " SP",
    giveup_answer_label: "Kebenaran",
    giveup_answer_closure: "Inilah yang sebenarnya terjadi",
    giveup_answer_done: "Mengerti",
    giveup_answer_failed: "Jawaban tidak dapat ditampilkan. Silakan coba lagi",
    giveup_reward_label: "Dihemat",
    giveup_reveal_action: "Lihat jawaban",
    giveup_leave_mute: "Keluar (jangan tanya lagi hari ini)",
    // chat page
    chat_load_failed: "Gagal memuat percakapan",
    chat_send_failed: "Gagal mengirim, silakan coba lagi",
    chat_loading: "Memuat berkas kasus...",
    chat_not_found: "Kasus tidak ditemukan",
    chat_ended: "Percakapan selesai",
    chat_enter_hint: "Tekan Enter untuk mengirim, Shift + Enter untuk baris baru",
    chat_progress: "Kemajuan",
    chat_stat_questions: "Pertanyaan",
    chat_stat_duration: "Durasi",
    chat_stat_goals: "Tujuan",
    chat_stat_likes: "Suka",
    chat_answer_yes: "Ya",
    chat_answer_no: "Tidak",
    chat_answer_both: "Ya & Tidak",
    chat_answer_unrelated: "Tidak relevan",
    chat_case_closed: "Kasus Ditutup",
    // puzzle_create
    puzzle_create_title: "Buat Teka-teki Baru",
    puzzle_create_ai_tab: "AI Buat Soal",
    puzzle_create_manual_tab: "Buat sendiri",
    puzzle_create_ai_title: "Selidiki sebuah misteri",
    puzzle_create_ai_description: "Detektif pendamping AI akan menyelidiki teka-teki orisinal untukmu. Pilih tema, nyalakan lampu untuk menyelidiki, dan jelajahi cerita dalam kegelapan.",
    puzzle_create_ai_button: "Mulai penyelidikan",
    puzzle_create_generating: "Membuat...",
    puzzle_create_title_label: "Judul Teka-teki",
    puzzle_create_title_placeholder: "Beri nama untuk teka-teki Anda",
    puzzle_create_soup_label: "Cerita Asli",
    puzzle_create_soup_placeholder: "Jelaskan situasi awal teka-teki (semakin sederhana dan penuh teka-teki semakin baik)",
    puzzle_create_truth_label: "Jawaban",
    puzzle_create_truth_placeholder: "Kebenaran teka-teki (hanya terlihat oleh pembuat dan pengguna yang telah menyelesaikannya)",
    puzzle_create_truth_hidden: "Klik \"Tampilkan Jawaban\" untuk melihat jawaban teka-teki",
    puzzle_create_show_truth: "Tampilkan Jawaban",
    puzzle_create_show_truth_dialog_title: "Konfirmasi Lihat Jawaban",
    puzzle_create_show_truth_dialog_description: "Setelah melihat jawaban, Anda tidak akan bisa lagi mengalami teka-teki ini sebagai penantang. Yakin ingin melihat?",
    puzzle_create_show_truth_confirm: "Konfirmasi Lihat",
    puzzle_create_challenge: "Coba Tantangan",
    puzzle_create_try_self: "Coba Sendiri",
    puzzle_create_regenerate: "Buat Ulang Soal",
    puzzle_create_publish: "Kirim Teka-teki",
    puzzle_create_ai_fill: "Buat Cerdas",
    puzzle_create_ai_fill_free: "Gratis kali ini",
    puzzle_create_ai_fill_failed: "Gagal menghasilkan AI",
    puzzle_create_ai_mode_title: "Buat Cerdas",
    puzzle_create_ai_mode_fill: "Isi Otomatis",
    puzzle_create_ai_mode_fill_desc: "Hanya mengisi kolom yang kosong",
    puzzle_create_ai_mode_optimize: "Optimasi Penuh",
    puzzle_create_ai_mode_optimize_desc: "Optimalkan berdasarkan konten yang ada",
    puzzle_create_ai_extra_prompt: "Petunjuk tambahan (opsional)",
    puzzle_create_ai_extra_prompt_placeholder: "Contoh: Lebih menyeramkan, tambahkan latar kampus...",
    lantern_brewing: "Meracik misteri…",
    lantern_drag_hint: "Seret cahaya · Temukan petunjuk",
    lantern_waiting: "Mempersiapkan misteri…",
    lantern_ready: "Misteri siap",
    lantern_gen_failed: "Pembuatan gagal\nSilakan coba lagi nanti",
    lantern_back: "Kembali",
    puzzle_create_targets_label: "Target",
    puzzle_create_add_target: "Tambah Target",
    puzzle_create_origin_label: "Asal",
    puzzle_create_origin_original: "Asli",
    puzzle_create_origin_repost: "Repost",
    puzzle_create_author_name: "Nama Penulis Asli",
    puzzle_create_author_name_placeholder: "Masukkan nama penulis asli",
    puzzle_create_creating: "Mengirim...",
    puzzle_create_edit_title: "Edit Teka-teki",
    puzzle_create_save_changes: "Simpan Perubahan",
    puzzle_create_publish_success_title: "Berhasil Dikirim",
    puzzle_create_publish_success_message: "Teka-teki berhasil dikirim, menunggu peninjauan",
    puzzle_create_publish_success_try: "Coba Sekarang",
    puzzle_create_publish_success_back: "Kembali ke Beranda",
    puzzle_create_publish_failed: "Gagal mengirim, harap coba lagi",
    puzzle_create_difficulty: "Tingkat Kesulitan",
    puzzle_create_tags: "Tag",
    puzzle_create_tags_hint: "Opsional, maks 3",
    puzzle_create_preview: "Pratinjau",
    puzzle_create_collapse: "Tutup",
    puzzle_create_expand: "Buka Pratinjau",
    puzzle_create_ready: "Semua kolom wajib sudah lengkap, siap dipublikasikan",
    puzzle_create_incomplete: "Harap lengkapi semua kolom wajib",
    // puzzles_list
    puzzle_list_title: "Daftar Teka-teki",
    puzzle_list_empty_title: "Belum pernah menyelesaikan teka-teki",
    puzzle_list_empty_description: "Pilih teka-teki untuk mulai menyelesaikan!",
    puzzle_list_empty_button: "Mulai Menyelesaikan",
    puzzle_list_active: "Sedang Berlangsung",
    puzzle_list_completed: "Selesai",
    puzzle_list_delete_success: "Berhasil dihapus",
    puzzle_list_delete_failed: "Gagal menghapus",
    puzzle_delete_confirm_title: "Hapus teka-teki ini?",
    puzzle_delete_confirm_description: "Teka-teki akan disembunyikan dari daftar dan halaman publik. Saat ini tindakan ini belum dapat dipulihkan di Web.",
    puzzle_delete_confirm_action: "Hapus teka-teki",
    puzzle_list_loading: "Memeriksa berkas kasus...",
    // recharge
    recharge_title: "Pusat Isi Ulang",
    recharge_insufficient_balance: "Saldo tidak cukup, silakan isi ulang",
    recharge_balance: "Saldo Saat Ini",
    recharge_balance_label: "Scenigma Points",
    recharge_select_amount: "Pilih Jumlah Isi Ulang",
    recharge_selected: "Dipilih",
    recharge_confirm: "Konfirmasi Isi Ulang",
    recharge_processing: "Memproses...",
    recharge_confirm_amount: "Konfirmasi Isi Ulang",
    recharge_subscribed: "Berlangganan",
    recharge_back: "Kembali",
    recharge_launching_payment: "Memproses pembayaran...",
    recharge_verifying: "Memverifikasi pembelian...",
    recharge_subscription_section: "Langganan saat ini",
    recharge_sp_unit: "SP",
    recharge_sub_name: "Scenigma Detective Lite",
    recharge_sub_desc: "600 SP/bulan + bonus check-in",
    recharge_sub_period: "bulan",
    recharge_sub_perk1: "600 SP per bulan",
    recharge_sub_perk2: "Check-in harian 7 SP",
    recharge_basic_name: "Scenigma Detective Basic",
    recharge_basic_desc: "Tingkat dasar gratis",
    recharge_basic_perk: "Check-in 2SP/hari",
    recharge_basic_price: "Gratis",
    profile_check_in_success_lite: "Check-in: +7 SP (manfaat Lite aktif)",
    recharge_desc_300: "Coba dulu",
    recharge_desc_900: "Teka-teki ringan",
    recharge_desc_1500: "Ahli teka-teki",
    recharge_desc_3000: "Petualangan detektif",
    // discover
    discover_title: "Temukan Teka-teki",
    discover_pickup_title: "Pilihan",
    discover_new: "Buat Baru",
    discover_latest: "Terbaru",
    discover_hot_today: "Populer Hari Ini",
    discover_hot_week: "Populer Minggu Ini",
    discover_login_warning: "Harap masuk terlebih dahulu~",
    discover_loading: "Mencari petunjuk...",
    // profile
    profile_title: "Profil",
    profile_not_logged_in: "Belum Masuk",
    profile_not_logged_in_description: "Masuk untuk melihat data pribadi dan menyimpan progres teka-teki",
    profile_login_now: "Masuk Sekarang",
    profile_avatar_alt: "Avatar Pengguna",
    profile_coins: "Scenigma Points",
    coins_unit: "SP",
    profile_recharge: "Isi Ulang",
    profile_check_in: "Check-in",
    profile_check_in_success: "Check-in: +2 SP",
    profile_check_in_already: "Sudah check-in hari ini",
    profile_network_error: "Masalah Jaringan",
    profile_tab_created: "Yang Saya Buat",
    profile_tab_liked: "Yang Saya Suka",
    profile_empty_created_title: "Belum ada teka-teki yang dibuat",
    profile_empty_created_description: "Buat teka-teki pertama Anda dan bagikan dengan semua orang",
    profile_create_puzzle: "Buat Teka-teki",
    profile_empty_liked_title: "Belum ada teka-teki yang disukai",
    profile_empty_liked_description: "Pergi ke halaman Temukan untuk menjelajahi lebih banyak teka-teki menarik",
    profile_go_discover: "Ke Temukan",
    profile_edit_nickname_title: "Edit Nama Panggilan",
    profile_edit_nickname_description: "Harap masukkan nama panggilan baru (maksimal 12 karakter)",
    profile_edit_nickname_placeholder: "Harap masukkan nama panggilan",
    profile_edit_nickname_max: "Nama panggilan tidak boleh melebihi 12 karakter",
    profile_edit_nickname_saved: "Nama panggilan telah diperbarui",
    profile_edit_nickname_failed: "Gagal memperbarui nama panggilan, nama panggilan asli telah dipulihkan",
    profile_edit_nickname_cancel: "Batal",
    profile_edit_nickname_save: "Simpan",
    profile_avatar_upload_error: "Harap pilih file gambar",
    profile_avatar_size_error: "Ukuran gambar tidak boleh melebihi 5MB",
    profile_avatar_updated: "Avatar telah diperbarui",
    // puzzle-card
    puzzle_card_publish: "Publikasikan",
    puzzle_card_reviewing: "Sedang Ditinjau",
    puzzle_card_rejected: "Pelanggaran",
    puzzle_card_completed: "Selesai",
    puzzle_card_publish_failed: "Publikasi gagal, harap coba lagi",
    puzzle_card_publish_retry: "Publikasi gagal, harap coba lagi",
    puzzle_card_submitted_review: "Telah Dikirim untuk Ditinjau",
    puzzle_card_original: "Asli",
    puzzle_card_repost: "Repost",
    puzzle_card_anonymous: "Anonim",
    puzzle_card_author_default: "Sang Misteri",
    puzzle_card_new_this_week: "Baru minggu ini",
    puzzle_card_solved_count: "diselesaikan",
    // settings
    settings_title: "Pengaturan",
    settings_language: "Pengaturan Bahasa",
    settings_privacy_policy: "Kebijakan Privasi",
    settings_terms_of_service: "Ketentuan Layanan",
    settings_logout: "Keluar",
    settings_logout_confirm_title: "Konfirmasi Keluar",
    settings_logout_confirm_description: "Setelah keluar, Anda tidak akan dapat mengakses data pribadi dan perlu masuk lagi.",
    settings_logout_confirm_cancel: "Batal",
    settings_logout_confirm_action: "Konfirmasi Keluar",
    settings_logout_success: "Berhasil keluar",
    settings_discord_title: "Gabung Discord",
    settings_discord_desc: "Beri masukan dan dapatkan kabar terbaru",
    settings_discord_join: "Gabung",
    settings_logout_failed: "Gagal keluar",
    settings_delete_account: "Hapus Akun",
    settings_delete_account_confirm_title: "Konfirmasi Penghapusan Akun",
    settings_delete_account_confirm_description: "Menghapus akun akan menghapus secara permanen semua konten terkait (profil akun, termasuk data puzzle yang dipublikasikan). Penghapusan akan ditinjau dan dikonfirmasi oleh staf layanan pelanggan, diharapkan selesai dalam 14 hari kerja. Anda akan diberitahu melalui email ketika penghapusan dieksekusi. Selama proses ini, Anda dapat membatalkan penghapusan akun kapan saja dengan masuk kembali.",
    settings_delete_account_confirm_cancel: "Batal",
    settings_delete_account_confirm_action: "Konfirmasi Penghapusan",
    settings_delete_account_success: "Permintaan penghapusan akun telah dikirim",
    settings_delete_account_failed: "Gagal mengirim permintaan penghapusan akun",
    settings_delete_account_network_error: "Masalah jaringan, silakan coba lagi",
    settings_theme: "Tema",
    settings_theme_light: "Terang",
    settings_theme_dark: "Gelap",
    settings_preferences: "Pengaturan & Preferensi",
    topbar_login_account: "Masuk",
    topbar_login_bonus: "Mulai bernalar bebas sekarang",
    topbar_community_join: "Gabung komunitas",
    topbar_community_qq: "Grup QQ",
    topbar_community_pending: "Tautan grup belum dikonfigurasi",
    settings_section_appearance: "Tampilan",
    settings_section_community: "Komunitas",
    settings_section_account: "Akun",
    settings_redeem_code: "Kode penukaran",
    settings_redeem_code_desc: "Masukkan kode acara atau komunitas untuk mendapatkan SP",
    settings_redeem_code_placeholder: "Masukkan kode",
    settings_redeem_code_action: "Tukarkan",
    settings_redeem_code_redeeming: "Menukarkan...",
    settings_redeem_code_success: "Berhasil ditukar: {amount} SP",
    settings_redeem_code_invalid: "Kode tidak valid atau sudah kedaluwarsa",
    settings_redeem_code_already_redeemed: "Kode ini sudah pernah Anda tukarkan",
    settings_redeem_code_network_error: "Penukaran gagal. Silakan coba lagi",
    login_account_deletion_title: "Permintaan Penghapusan Akun",
    login_account_deletion_description: "Akun Anda memiliki permintaan penghapusan yang tertunda. Klik 'Lanjutkan' untuk masuk dan membatalkan permintaan penghapusan akun.",
    login_account_deletion_continue: "Lanjutkan",
    login_account_deletion_cancel: "Batal",
    login_account_deletion_revoke_success: "Permintaan penghapusan akun dibatalkan",
    login_account_deletion_revoke_failed: "Gagal membatalkan permintaan penghapusan akun",
    login_account_deletion_network_error: "Masalah jaringan, silakan masuk lagi",
    // login tutorial
    tutorial_welcome: "Selamat datang di Teka-teki Situasional, didukung oleh AI.",
    tutorial_ask_familiar: "Sebelum memulai, izinkan saya bertanya:\nApakah Anda familiar dengan permainan teka-teki situasional?",
    tutorial_response_yes: "Baik, izinkan saya langsung memperkenalkan cara menggunakan aplikasi ini dengan cepat.",
    tutorial_response_no: "Baik! Permainan teka-teki situasional bekerja seperti ini: satu pihak mengajukan pertanyaan berdasarkan 'skenario teka-teki', pihak lain menjawab 'ya', 'tidak' atau 'tidak relevan' berdasarkan 'kebenaran', sampai kebenaran terungkap.",
    tutorial_intro_demo: "Selanjutnya, saya akan memberikan skenario teka-teki kepada Anda. Silakan pilih pertanyaan yang ingin Anda tanyakan, dan saya akan menjawab. Karena ini adalah demo tutorial, saya akan langsung memberikan opsi; saat bermain sebenarnya, Anda dapat mengetik pertanyaan apa pun yang ingin Anda tanyakan.",
    tutorial_congrats: "Selamat! Anda sudah memahami dasar cara bermain teka-teki situasional! Sekarang, masuk ke akun Anda, mari kita lakukan lebih banyak pemecahan teka-teki situasional bersama! Izinkan saya menyambut Anda lagi:",
    tutorial_puzzle_demo: "Seorang pria buta memasuki sebuah restoran dan memesan sup kura-kura. Setelah mencicipi satu suap, dia tiba-tiba menangis kesakitan, keluar dari restoran dan bunuh diri. Bisakah Anda menebak kebenaran di balik ini?",
    tutorial_option_1: "Apakah dia diracuni?",
    tutorial_option_2: "Apakah dia mengingat sesuatu?",
    tutorial_option_3: "Apakah dia pernah terdampar di pulau terpencil dengan teman, hampir mati kelaparan, ketika dia minum 'sup kura-kura' yang diberikan temannya?",
    tutorial_option_4: "Apakah dia mengingat kura-kura yang pernah dipeliharanya?",
    tutorial_option_5: "Apakah dia menyadari bahwa 'sup kura-kura' yang diminumnya sebenarnya terbuat dari daging temannya, itulah sebabnya dia bertahan sampai diselamatkan, sementara temannya sayangnya meninggal.",
    tutorial_got_it: "Mengerti",
    tutorial_answer_yes: "Ya",
    tutorial_answer_no: "Tidak",
    // navigation
    // themes
    theme_label: "Tema",
    theme_all: "Semua",
    theme_honkaku: "Honkaku",
    theme_henkaku: "Henkaku",
    theme_suspense: "Ketegangan",
    theme_casual: "Santai",
    theme_hardcore: "Hardcore",
    theme_horror: "Horor Ringan",
    theme_heartwarming: "Menghangatkan Hati",
    // discover sort
    discover_sort_latest: "Terbaru",
    discover_sort_hot_today: "Populer Hari Ini",
    discover_sort_hot_week: "Populer Minggu Ini",
    // discover filter & sort (web)
    discover_filter_all: "Semua",
    discover_filter_hot: "Populer",
    discover_filter_latest: "Terbaru",
    discover_difficulty_easy: "Mudah",
    discover_difficulty_medium: "Sedang",
    discover_difficulty_hard: "Sulit",
    discover_sortby_composite: "Gabungan",
    discover_sortby_newest: "Terbaru",
    discover_sortby_most_liked: "Paling Disukai",
    discover_sortby_most_played: "Paling Dimainkan",
    discover_no_result: "Tidak ditemukan teka-teki yang sesuai",
    discover_puzzle_count: "teka-teki",
    nav_puzzles: "Teka-teki",
    nav_discover: "Temukan",
    nav_profile: "Profil",
    nav_create: "Buat Teka-teki",
    nav_recharge: "Isi Ulang",
    nav_settings: "Pengaturan",
    nav_my_puzzles: "Teka-teki Saya",
    sidebar_investigation: "Investigasi",
    sidebar_case_files: "Berkas Kasus",
    sidebar_account: "Akun",
    sidebar_tagline: "Teka-teki Berpikir Lateral"
};
